(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[14086,48704,43449,18740,69655,84043],{

/***/ 73536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "13",
        height: "13",
        fill: "none",
        viewBox: "0 0 13 13",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#fff",
            d: "M.963 12.46L0 11.501 5.294 6.23 0 .958.963 0l5.293 5.272L11.55 0l.963.958L7.219 6.23l5.294 5.271-.963.959-5.294-5.272L.963 12.46z"
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (CloseIcon);


/***/ }),

/***/ 34532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CompactOffer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81331);
/* harmony import */ var _styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(92113);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25416);








function CompactOffer({ offer , zone , classes , offerMessage , showAllOffers , template ="default"  }) {
    const { domain  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const offerItems = offer ? [
        {
            ...offer
        }
    ] : showAllOffers ? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getOffersByPlacement */ .um)(domain?.defaultOffers, "thankYou") : [
        {
            ...(0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getOffersByPlacement */ .um)(domain?.defaultOffers, "thankYou")[0]
        }, 
    ];
    if (offerItems.length) {
        const offersList = offerItems.map((offerItem)=>{
            const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offerItem);
            const phoneNumberMessage = offerItem?.attributes.phoneNumberMessage ? offerItem?.attributes.phoneNumberMessage : offerItem?.hiddenAttributes.phoneNumberMessage ? offerItem?.hiddenAttributes.phoneNumberMessage : "";
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().container)} ${classes?.container ?? ""} w-full  relative  mx-auto z-50 mb-[10px] px-4 py-2 border rounded-5`,
                style: {
                    borderColor: "#e3e3e3",
                    background: "#F6F6F6"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex flex-wrap items-center justify-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `w-28 mt-4 mb-3 sm:mb-0 sm:mt-0  sm:border-r pr-0 md:pr-3 mr-0 md:mr-3 ${classes?.image ?? ""}`,
                            style: {
                                borderColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default().offerBorderColor)
                            },
                            children: offerItem.logo && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: offerItem.logo.fullPath,
                                alt: offerItem.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "w-full sm:w-[200px] flex-grow mb-3 sm:mb-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                style: {
                                    color: "#464c4d"
                                },
                                className: "text-center text-[14px]",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    dangerouslySetInnerHTML: {
                                        __html: offerMessage ?? phoneNumberMessage ?? phoneNumber ? "Call Now to Get the Best Deal" : "Review Offer and Coverage"
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "min-w-[135px] w-auto mb-3 sm:mb-0",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_affiliateOfferUrl__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                zone: zone,
                                style: {
                                    color: "white",
                                    backgroundColor: (_styles_variables_businessphonepricesVariables_module_scss__WEBPACK_IMPORTED_MODULE_6___default().autumnGlory)
                                },
                                target: "_blank",
                                offer: offerItem,
                                template: template,
                                customHref: phoneNumber ? `tel:${phoneNumber ?? ""}` : undefined,
                                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().link)} ${classes?.button ?? ""} flex justify-center rounded-5 text-center px-[10px] py-[6px] text-[15px]`,
                                children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber) ?? "View Deal"
                            })
                        })
                    ]
                })
            }, offerItem.id);
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: offersList
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 98778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ ApiLoadingLabels; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(87668);
/* harmony import */ var _ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _loader__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95301);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);





let loadingMessages = [
    "Working on it…",
    "Almost ready…",
    "Finalizing results…", 
];
const ApiLoadingLabels = ({ withLoading  })=>{
    const { category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    if (category?.config?.apiLoadingMessages?.length) {
        loadingMessages = category.config.apiLoadingMessages;
    }
    const { 0: currentMessageIndex , 1: setCurrentMessageIndex  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const { 0: isAnimating , 1: setIsAnimating  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const interval = setInterval(()=>{
            setIsAnimating(true);
            setTimeout(()=>{
                setCurrentMessageIndex((prevIndex)=>(prevIndex + 1) % loadingMessages.length);
                setIsAnimating(false);
            }, 300); // Wait for slide-up animation to complete
        }, 2000); // Change message every 2 seconds
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["loading-container"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["label-wrapper"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: `${(_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["loading-label"])} ${isAnimating ? (_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["slide-up"]) : (_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["slide-in"])}`,
                    children: loadingMessages[currentMessageIndex]
                }, currentMessageIndex),
                withLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_loader__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    className: (_ApiLoadingLabels_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["api-loading-wrapper"]),
                    size: 30
                })
            ]
        })
    });
};


/***/ }),

/***/ 7004:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OtpForm; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/form/fields/styles.module.scss
var styles_module = __webpack_require__(14525);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/lib/shared/lodash.ts
var lodash = __webpack_require__(90969);
;// CONCATENATED MODULE: ./src/components/shared/form/fields/otp.tsx




const digitMargin = 10;
function OTP({ numberOfDigits , otp , isLoading , error , setError , otpValue , setOTP  }) {
    const { 0: isFieldFocused , 1: setIsFieldFocused  } = (0,react.useState)(false);
    const otpFieldRef = (0,react.useRef)(null);
    const onKeyDown = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
        }
        if (e.key === "Delete" || e.key === "Backspace") {
            const index = (0,lodash/* findLastIndex */.qr)(otpValue, (o)=>o !== "");
            handleChange("", index);
        }
    };
    const handleFieldChange = (e)=>{
        const digitsRegex = new RegExp(/^[0-9]*$/);
        if (!digitsRegex.test(e.target.value)) return;
        if (e.target.value.length === 1) {
            if (error) setError(false);
            const index = (0,lodash/* findIndex */.cx)(otpValue, (o)=>o === "");
            handleChange(e.target.value, index);
        }
    };
    const handleChange = (value, index)=>{
        const tempArray = [
            ...otpValue
        ];
        tempArray[index] = value;
        setOTP(tempArray);
    };
    const handlePaste = (e)=>{
        e.preventDefault();
        const digitsRegex = new RegExp(/^[0-9]*$/);
        const clipboardData = e.clipboardData.getData("Text");
        if (!digitsRegex.test(clipboardData)) return;
        const tempArray = new Array(numberOfDigits).fill("");
        for (const [i, char] of clipboardData.split("").entries()){
            if (digitsRegex.test(char)) {
                tempArray[i] = char;
            } else {
                break;
            }
        }
        setOTP(tempArray);
    };
    const handleSubmit = async ()=>{
        const { success  } = await otp.handleSubmit(otpValue.join(""));
        if (!success) setOTP(new Array(numberOfDigits).fill(""));
        setError(!success);
    };
    (0,react.useEffect)(()=>{
        if (otpValue.every((item)=>!!item)) {
            void handleSubmit();
        }
    }, [
        otpValue
    ]);
    (0,react.useEffect)(()=>{
        setIsFieldFocused(!isLoading);
        if (!isLoading && otpFieldRef) {
            setTimeout(()=>{
                otpFieldRef.current?.focus();
            }, 100);
        }
    }, [
        isLoading
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(styles_module_default())["otp-field"]} relative`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex",
                children: new Array(numberOfDigits).fill(0).map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `${(styles_module_default())["otp-input"]} ${isLoading ? (styles_module_default()).disabled : ""} ${isFieldFocused && (0,lodash/* findIndex */.cx)(otpValue, (o)=>o === "") === index ? (styles_module_default()).focused : ""} ${error ? (styles_module_default()).error : ""} `,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: otpValue[index]
                        })
                    }, index))
            }),
            !isLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: otpFieldRef,
                style: {
                    width: isFieldFocused ? "45px" : "100%",
                    left: Math.max(isFieldFocused ? (0,lodash/* findIndex */.cx)(otpValue, (o)=>o === "") * (45 + digitMargin * 2) : 0, 0)
                },
                name: "otp",
                type: "tel",
                autoComplete: "off",
                className: (styles_module_default())["otp-hidden-input"],
                maxLength: numberOfDigits,
                onKeyDown: onKeyDown,
                value: "",
                onChange: (e)=>handleFieldChange(e),
                onFocus: ()=>setIsFieldFocused(true),
                onBlur: ()=>setIsFieldFocused(false),
                onPaste: handlePaste
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/shared/form/styles.module.scss
var form_styles_module = __webpack_require__(67408);
var form_styles_module_default = /*#__PURE__*/__webpack_require__.n(form_styles_module);
// EXTERNAL MODULE: ./src/components/shared/form/OtpForm/styles.module.scss
var OtpForm_styles_module = __webpack_require__(41985);
var OtpForm_styles_module_default = /*#__PURE__*/__webpack_require__.n(OtpForm_styles_module);
// EXTERNAL MODULE: ./src/components/shared/loader/index.tsx
var loader = __webpack_require__(95301);
// EXTERNAL MODULE: ./src/components/shared/modal/index.tsx
var modal = __webpack_require__(18740);
// EXTERNAL MODULE: ./src/lib/shared/form.ts + 1 modules
var shared_form = __webpack_require__(198);
// EXTERNAL MODULE: ./src/components/svg/closeIcon.tsx
var closeIcon = __webpack_require__(69655);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/form/OtpForm/index.tsx











let outerCounter = 0;
const numberOfDigits = 4;
let interval;
function OtpForm({ phoneNumber , className , colors , classes , isLoading , otp , handleFieldChange  }) {
    const { locale , domain , domainNameTranslation  } = (0,useDomainContext/* useDomainContext */.w)();
    const { 0: time , 1: setTime  } = (0,react.useState)(otp.countDownTime);
    const { 0: isTimeActive , 1: setIsTimerActive  } = (0,react.useState)(false);
    const { 0: error , 1: setError  } = (0,react.useState)(false);
    const [otpValue, setOTP] = react.useState(new Array(numberOfDigits).fill(""));
    const { 0: isPhoneModalActive , 1: setIsPhoneModalActive  } = (0,react.useState)(false);
    const { 0: newPhoneNumber , 1: setNewPhoneNumber  } = (0,react.useState)("");
    const { 0: newPhoneNumberError , 1: setNewPhoneNumberError  } = (0,react.useState)(null);
    const { 0: oldPhoneNumber , 1: setOldPhoneNumber  } = (0,react.useState)(phoneNumber);
    const startTime = ()=>{
        if (!isTimeActive) {
            setIsTimerActive(true);
            interval = setInterval(()=>{
                if (time > 1) {
                    setTime(outerCounter - 1);
                    outerCounter -= 1;
                }
                if (outerCounter === 0) {
                    clearInterval(interval);
                    setTime(otp.countDownTime);
                    outerCounter = otp.countDownTime;
                    setIsTimerActive(false);
                }
            }, 1000);
        } else {
            clearInterval(interval);
            setTime(otp.countDownTime);
            outerCounter = otp.countDownTime;
            interval = setInterval(()=>{
                if (time > 1) {
                    setTime(outerCounter - 1);
                    outerCounter -= 1;
                }
                if (outerCounter === 0) {
                    clearInterval(interval);
                    setTime(otp.countDownTime);
                    outerCounter = otp.countDownTime;
                    setIsTimerActive(false);
                }
            }, 1000);
        }
    };
    const handleResendCode = async (e)=>{
        e.preventDefault();
        const { success  } = await otp.handleResend();
        if (success) {
            startTime();
        }
    };
    const handleModalClose = ()=>{
        setIsPhoneModalActive(false);
        setTimeout(()=>{
            otp.handleScrollFormTop();
        }, 50);
    };
    const getTimeLeft = ()=>{
        const minutes = Math.floor(time / 60);
        const seconds = (time - minutes * 60).toLocaleString("es-US", {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        return `${minutes.toLocaleString("es-US", {
            minimumIntegerDigits: 2,
            useGrouping: false
        })}:${seconds}`;
    };
    const validateNewPhoneNumber = async (value)=>{
        const { message , valid  } = await (0,shared_form/* fieldValidation */.wY)({
            mask: "us-phone",
            isRequired: true,
            niceName: domain?.translations?.[`${domainNameTranslation}_OtpPhoneNumber`] ?? "Phone number",
            title: "Phone number",
            label: null,
            codeName: "",
            defaultValue: null,
            defaultValues: null,
            fieldType: "number",
            placeholder: null,
            pattern: null,
            minValue: null,
            maxValue: null,
            note: null,
            autocomplete: null,
            dependency: null,
            meta: null,
            conditionalLogic: null,
            validationType: "phoneNumber"
        }, value, locale, "US", undefined, domain);
        setNewPhoneNumberError(message ? message : null);
        return valid;
    };
    const handlePhoneNumberChange = (value)=>{
        setNewPhoneNumberError(null);
        setNewPhoneNumber((0,shared_form/* handleFieldMasking */.yr)("us-phone", value));
    };
    const handlePhoneNumberBlur = (value)=>{
        void validateNewPhoneNumber(value);
    };
    const handlePhoneNumberEdit = async (e)=>{
        e.preventDefault();
        if (await validateNewPhoneNumber(newPhoneNumber)) {
            if (newPhoneNumber === oldPhoneNumber) {
                setNewPhoneNumberError(domain?.translations?.[`${domainNameTranslation}_OtpPleaseEnterANewPhoneNumber`] ?? "Please enter a new phone number");
            } else {
                handleFieldChange({
                    mask: null,
                    codeName: "phoneNumber"
                }, newPhoneNumber);
            }
        } else {
            return;
        }
    };
    const handleEditPhoneNumberCancel = ()=>{
        setNewPhoneNumber("");
        setNewPhoneNumberError(null);
        handleModalClose();
    };
    const submitFormWithNewPhoneNumber = async ()=>{
        const { success  } = await otp.handleEditPhoneNumber(newPhoneNumber);
        if (success) {
            setNewPhoneNumber("");
            setNewPhoneNumberError(null);
            handleModalClose();
            setOldPhoneNumber(phoneNumber);
            startTime();
        } else {
            setNewPhoneNumberError(domain?.translations?.[`${domainNameTranslation}_OtpPleaseEnterAValidUSPhoneNumber`] ?? "Please enter a valid US phone number");
            handleFieldChange({
                mask: null,
                codeName: "phoneNumber"
            }, oldPhoneNumber);
        }
    };
    (0,react.useEffect)(()=>{
        outerCounter = otp.countDownTime;
        startTime();
    }, []);
    (0,react.useEffect)(()=>{
        if (phoneNumber !== oldPhoneNumber) {
            void submitFormWithNewPhoneNumber();
        }
    }, [
        phoneNumber
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(OtpForm_styles_module_default()).otpContainer} ${className ?? ""} overflow-hidden`,
        id: "verify-otp",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "text-xl font-bold",
                        children: domain?.translations?.[`${domainNameTranslation}_OtpVerificationCode`] ?? "Verification Code"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "font-light text-base mt-2 mb-4",
                        children: [
                            domain?.translations?.[`${domainNameTranslation}_OtpWeNeedToVerifyYourPhoneNumber`] ?? "We need to verify your phone number",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "font-bold inline-block " + (OtpForm_styles_module_default()).phoneNumber,
                                id: "phone-number",
                                children: oldPhoneNumber
                            }),
                            ",",
                            domain?.translations?.[`${domainNameTranslation}_OtpWeAreSendingYouTheCodeNow`] ?? "we are sending you the code now"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: `${(form_styles_module_default())["form-field"]} ${(OtpForm_styles_module_default())["otp-field"]}`,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OTP, {
                                numberOfDigits: numberOfDigits,
                                otp: otp,
                                setError: setError,
                                error: error,
                                isLoading: isLoading,
                                otpValue: otpValue,
                                setOTP: setOTP
                            }),
                            error && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: `${(form_styles_module_default())["error-message"]} ${(OtpForm_styles_module_default())["error-message"]}`,
                                children: domain?.translations?.[`${domainNameTranslation}_OtpWrongCodeTryAgain`] ?? "Wrong code, try again"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "text-center font-light mt-6 mb-7",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: `${(OtpForm_styles_module_default())["info-message"]} mb-5`,
                                children: !isTimeActive ? domain?.translations?.[`${domainNameTranslation}_OtpDidNotGetTheVerificationCode`] ?? "Didn't get the verification code?" : domain?.translations?.[`${domainNameTranslation}_OtpYouCanSendAnotherVerificationCodeIn`] ?? "You can send another verification code in"
                            }),
                            isTimeActive ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: getTimeLeft()
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                style: {
                                    border: "none"
                                },
                                className: (OtpForm_styles_module_default()).button,
                                onClick: (e)=>handleResendCode(e),
                                children: domain?.translations?.[`${domainNameTranslation}_OtpResendCode`] ?? "Resend Code"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                style: {
                                    color: colors?.primaryColor,
                                    borderColor: colors?.primaryColor
                                },
                                className: (OtpForm_styles_module_default()).button,
                                onClick: (e)=>{
                                    e.preventDefault();
                                    setIsPhoneModalActive(true);
                                },
                                children: domain?.translations?.[`${domainNameTranslation}_OtpEditPhoneNumber`] ?? "Edit Phone Number"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        style: {
                            backgroundColor: colors?.primaryColor
                        },
                        className: `${(form_styles_module_default())["submit-button"]} ${classes?.formButtonClassName ?? ""}`,
                        disabled: !otpValue.every((item)=>!!item),
                        type: "submit",
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                            size: 30
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: domain?.translations?.[`${domainNameTranslation}_OtpVerify`] ?? "Verify"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(modal["default"], {
                active: isPhoneModalActive,
                width: 600,
                wrapperClassName: (OtpForm_styles_module_default())["phone-number-modal-wrapper"],
                modalClassName: "rounded-10",
                onClose: ()=>handleEditPhoneNumberCancel(),
                closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "px-10 lg:px-16 py-10 font-poppins",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                            className: "font-bold text-center text-xl lg:text-2xl mb-5",
                            children: domain?.translations?.[`${domainNameTranslation}_OtpEditYourPhoneNumber`] ?? "Edit Your Phone Number"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                            onSubmit: handlePhoneNumberEdit,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: `${(form_styles_module_default())["form-field"]} ${newPhoneNumberError ? (form_styles_module_default()).error : ""} ${classes?.formFieldClassName ?? ""}`,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            className: `${(OtpForm_styles_module_default())["field-label"]} ${classes?.formFieldLabelClassName ?? ""} mb-2 font-light text-center`,
                                            style: {
                                                color: "grey"
                                            },
                                            children: domain?.translations?.[`${domainNameTranslation}_OtpEnterYourPhoneNumberForVerificationCode`] ?? "Enter your phone number for a verification code"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            className: `${classes?.fieldsClassName?.all ?? ""} ${(styles_module_default()).field}`,
                                            value: newPhoneNumber,
                                            type: "tel",
                                            onChange: (e)=>handlePhoneNumberChange(e.target.value),
                                            onBlur: (e)=>handlePhoneNumberBlur(e.target.value),
                                            placeholder: domain?.translations?.[`${domainNameTranslation}_OtpNewPhoneNumber`] ?? "New phone number"
                                        }),
                                        newPhoneNumberError && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (form_styles_module_default())["error-message"],
                                            children: newPhoneNumberError
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    style: {
                                        backgroundColor: colors?.primaryColor,
                                        width: "60%"
                                    },
                                    className: `${(form_styles_module_default())["submit-button"]} ${classes?.formButtonClassName ?? ""} mx-auto`,
                                    type: "submit",
                                    children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                        size: 30
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            children: domain?.translations?.[`${domainNameTranslation}_OtpEditWord`] ?? "Edit"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            onClick: ()=>handleEditPhoneNumberCancel(),
                            className: (OtpForm_styles_module_default()).button,
                            children: domain?.translations?.[`${domainNameTranslation}_OtpCancelWord`] ?? "Cancel"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 89036:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SmsTCPA; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42327);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function SmsTCPA({ buttonText , isFormInsideOffersModal  }) {
    const { domain , visitDetails  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const showSmsTCPA = domain.config?.showSmsTCPA && !visitDetails.trafficSource;
    // const linkColor = domain.config?.smsTCPALinkColor
    //     ? domain.config?.smsTCPALinkColor
    //     : "rgb(63, 127, 234)";
    return showSmsTCPA ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["checkbox-wrapper"]),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        id: `sms_tcpa${isFormInsideOffersModal ? "_isFormInsideOffersModal" : ""}`,
                        name: `sms_tcpa${isFormInsideOffersModal ? "_isFormInsideOffersModal" : ""}`
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: `sms_tcpa${isFormInsideOffersModal ? "_isFormInsideOffersModal" : ""}`,
                        className: `flex justify-center ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["checkbox-label"])} cursor-pointer mb-1`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    viewBox: "0,0,50,50",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5 30 L 20 45 L 45 5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    'By submitting this form or clicking the "',
                                    buttonText,
                                    '" button (or similar), you consent to receive SMS messages from ',
                                    domain.niceName,
                                    ". These may include case updates, appointment reminders, and One-Time Passwords (OTPs) for identity verification. Text STOP to opt out at any time."
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["checkbox-wrapper"])}  mt-1`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        id: `sms_tcpa_2${isFormInsideOffersModal ? "_isFormInsideOffersModal" : ""}`,
                        name: `sms_tcpa_2${isFormInsideOffersModal ? "_isFormInsideOffersModal" : ""}`
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: `sms_tcpa_2${isFormInsideOffersModal ? "_isFormInsideOffersModal" : ""}`,
                        className: `flex justify-center ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["checkbox-label"])} cursor-pointer mb-1`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().box),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    viewBox: "0,0,50,50",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5 30 L 20 45 L 45 5"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                children: [
                                    'By submitting this form or clicking the "',
                                    buttonText,
                                    '" button (or similar), you agree to receive promotional SMS messages from ',
                                    domain.niceName,
                                    ", including legal offers, news, and relevant content. Text STOP to unsubscribe at any time."
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 66891:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
const preDefinedAnswerSummaryConfigs = {
    autowarranty: [
        // {
        //     stepIndex: 1,
        //     fields: [
        //         {
        //             codeName: "manufacturingYear",
        //             gridArea: "manufacturingYear",
        //             placeSelf: "center start",
        //         },
        //     ],
        //     gridTemplateAreas: `
        //         "manufacturingYear"
        //     `,
        //     gridTemplateColumns: "auto",
        //     gridTemplateRows: "auto",
        // },
        {
            stepIndex: 2,
            fields: [
                {
                    codeName: "manufacturingYear",
                    gridArea: "manufacturingYear",
                    placeSelf: "start start",
                    className: "ml-4 text-sm md:text-md"
                },
                {
                    codeName: "vehicleMake",
                    gridArea: "vehicleMake",
                    className: "text-sm md:text-xl ml-4",
                    placeSelf: {
                        sm: "center start",
                        md: "end start"
                    }
                },
                {
                    codeName: "vehicleModel",
                    gridArea: "vehicleModel",
                    className: "text-sm md:text-xl ml-2",
                    placeSelf: {
                        sm: "center start",
                        md: "end start"
                    }
                }, 
            ],
            gridTemplateAreas: `
                "vehicleMakeImage vehicleMake vehicleModel"
                "vehicleMakeImage manufacturingYear ."
            `,
            gridTemplateColumns: "fit-content(300px) fit-content(300px) fit-content(300px)",
            gridTemplateRows: "auto auto"
        },
        {
            stepIndex: 3,
            fields: [
                {
                    codeName: "manufacturingYear",
                    gridArea: "manufacturingYear",
                    placeSelf: "start start",
                    className: "ml-4 text-sm md:text-md",
                    appendText: " / ${vehicleMileage} Miles"
                },
                {
                    codeName: "vehicleMake",
                    gridArea: "vehicleMake",
                    className: "text-sm md:text-xl ml-4",
                    placeSelf: {
                        sm: "center start",
                        md: "end start"
                    },
                    appendText: " ${vehicleModel}"
                }, 
            ],
            gridTemplateAreas: {
                sm: `
                 "vehicleMakeImage vehicleMake vehicleMake"
                 "vehicleMakeImage manufacturingYear ."
                 "vehicleMileage vehicleMileage vehicleMileage"
                `,
                md: `
                "vehicleMakeImage vehicleMake vehicleMake vehicleMake"
                "vehicleMakeImage manufacturingYear vehicleMileage vehicleMileage"
               `
            },
            gridTemplateColumns: {
                sm: "fit-content(300px) fit-content(300px) fit-content(300px)",
                md: "fit-content(300px) fit-content(300px) fit-content(300px)"
            },
            gridTemplateRows: "auto auto",
            extend: true
        }, 
    ]
};
preDefinedAnswerSummaryConfigs["auto-warranty"] = preDefinedAnswerSummaryConfigs.autowarranty;
/* harmony default export */ __webpack_exports__["Z"] = (preDefinedAnswerSummaryConfigs);


/***/ }),

/***/ 62085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18732);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _progressBar__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91354);
/* harmony import */ var _components_severalbrands_blog_secondSection_sideWidget_closeIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73536);





const FieldWrapper = ({ type , children , classes , showProgress , current , total , colors , shift , showStepNumberOnly , showBackButton , backButton , handlePrevStep , onModalCloseClick , tcpa  })=>{
    const components = {
        div: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().inner)} ${classes?.formStepInnerClassName ?? ""}`,
            children: children
        }),
        modal: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-modal-container"]),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-modal-close-button"]),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        onClick: onModalCloseClick,
                        type: "button",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_severalbrands_blog_secondSection_sideWidget_closeIcon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-modal-wrapper"]),
                    children: [
                        children,
                        showProgress && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_progressBar__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["progress-bar"])} ${classes?.formProgressbarClassName ?? ""}`,
                            current: current,
                            total: total,
                            color: colors?.progressBar,
                            shift: shift,
                            showStepNumberOnly: showStepNumberOnly
                        }),
                        tcpa,
                        showBackButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                            type: "button",
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["back-button"])} ${backButton?.class ?? ""}`,
                            onClick: ()=>backButton?.firstStepAction && current === 0 ? backButton.firstStepAction() : handlePrevStep(),
                            children: [
                                backButton?.label ?? "Previous",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["arrow-back"])
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    };
    return components[type];
};
/* harmony default export */ __webpack_exports__["Z"] = (FieldWrapper);


/***/ }),

/***/ 63697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ CalculatedYears; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function CalculatedYears({ field , onChange , value , className  }) {
    const checkIfSelectHasMinMaxValue = ()=>{
        if (field.maxValue?.value && field.minValue?.value && field.maxValue.type === "number" && field.minValue.type === "number" && field.maxValue.value > field.minValue.value) {
            return true;
        }
        return false;
    };
    const gettingArrayFromMaxMinValues = ()=>{
        const today = new Date();
        const year = today.getFullYear();
        const newArray = [];
        for(let i = parseInt(field.minValue?.value, 10); i <= parseInt(field.maxValue?.value, 10); i++){
            newArray.unshift({
                label: year - i,
                value: year - i,
                icon: null
            });
        }
        if (field.meta?.reverseOptions === "true") {
            return newArray.reverse();
        }
        return newArray;
    };
    const renderOptions = ()=>{
        const options = checkIfSelectHasMinMaxValue() ? gettingArrayFromMaxMinValues() : field.defaultValues?.options;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: options?.map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    value: option.value,
                    children: option.label
                }, index))
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().select)} ${!value ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().empty) : ""} ${className ?? ""}`,
        onChange: (e)=>onChange(e.target.value),
        name: field.codeName,
        value: value,
        id: field.codeName,
        children: [
            field.placeholder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                value: "",
                children: field.placeholder
            }),
            renderOptions()
        ]
    });
}


/***/ }),

/***/ 87217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function Checkbox({ field , onChange , className , value , primaryColor , ignoreOptionIcons , iconLocation ="start" , iconClassName , addConsentTags  }) {
    const { 0: checkboxValue , 1: setCheckboxValue  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(field.defaultValues?.options.map((option)=>{
        if (value.includes(option.value)) return option.value;
        return "";
    }) ?? []);
    const handleCheckboxChange = (value, index)=>{
        const tempValue = [
            ...checkboxValue
        ];
        tempValue[index] ? tempValue[index] = "" : tempValue[index] = value;
        onChange(tempValue.filter((item)=>item).join(","));
    };
    const renderOptions = ()=>field.defaultValues?.options?.map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().option),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        id: `${field.codeName}-${index}`,
                        value: option.value,
                        name: field.codeName,
                        //@ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        onClick: (e)=>handleCheckboxChange(e.target.value, index),
                        checked: checkboxValue[index] === option.value,
                        ...addConsentTags && {
                            "data-tf-element-role": `consent-opted-advertiser-input-${option.value}`
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: `${field.codeName}-${index}`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().box),
                                style: {
                                    borderColor: primaryColor,
                                    backgroundColor: checkboxValue[index] === option.value ? primaryColor : undefined
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    viewBox: "0,0,50,50",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5 30 L 20 45 L 45 5"
                                    })
                                })
                            }),
                            option?.icon && !ignoreOptionIcons && iconLocation === "start" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: `flex items-center mr-2 ${iconClassName ?? ""}`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: option?.icon?.fullPath,
                                    alt: option.label,
                                    className: "h-8 w-auto max-w-[50px]"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-sm flex items-center",
                                style: {
                                    transform: "translateY(1px)"
                                },
                                ...addConsentTags && {
                                    "data-tf-element-role": `consent-opted-advertiser-name-${option.value}`
                                },
                                children: option.label
                            }),
                            option?.icon && option?.icon?.fullPath && !ignoreOptionIcons && iconLocation === "end" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: `flex items-center ml-auto ${iconClassName ?? ""}`,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: option?.icon?.fullPath,
                                    alt: option.label,
                                    className: `
                                         h-8 w-auto max-w-[50px]
                                    `
                                })
                            })
                        ]
                    }, index)
                ]
            }, index));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setCheckboxValue(field.defaultValues?.options.map((option)=>{
            if (value.includes(option.value)) return option.value;
            return "";
        }) ?? []);
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkbox)} ${className ?? ""}`,
        children: renderOptions()
    });
}


/***/ }),

/***/ 83354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DatePicker; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);




let isSavedValueSet = false;
const months = [
    {
        label: "JAN",
        value: "0"
    },
    {
        label: "FEB",
        value: "1"
    },
    {
        label: "MAR",
        value: "2"
    },
    {
        label: "APR",
        value: "3"
    },
    {
        label: "MAY",
        value: "4"
    },
    {
        label: "JUN",
        value: "5"
    },
    {
        label: "JUL",
        value: "6"
    },
    {
        label: "AUG",
        value: "7"
    },
    {
        label: "SEP",
        value: "8"
    },
    {
        label: "OCT",
        value: "9"
    },
    {
        label: "NOV",
        value: "10"
    },
    {
        label: "DEC",
        value: "11"
    }, 
];
function DatePicker(props) {
    const { 0: day , 1: setDay  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { 0: month , 1: setMonth  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { 0: year , 1: setYear  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { 0: htmlDate , 1: setDate  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const monthsTranslation = __webpack_require__(96502)(`./${locale}.json`);
    const translateMonths = (key)=>monthsTranslation[key] ?? key;
    const { value , onChange , field , className  } = props;
    const gettingYearFromDays = (days)=>{
        const date = new Date();
        const last = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
        return last.getFullYear();
    };
    const gettingDateFromDays = (days)=>{
        const date = new Date();
        const last = new Date(date.getTime() + days * 24 * 60 * 60 * 1000);
        return last.toISOString().split("T")[0];
    };
    const gettingYearOptions = ()=>{
        const maxDate = field?.maxValue?.value ? field.maxValue.type === "date" ? new Date(field.maxValue.value).getFullYear() : gettingYearFromDays(parseInt(field.maxValue.value, 10)) : new Date().getFullYear();
        const minDate = field?.minValue?.value ? field.minValue.type === "date" ? new Date(field.minValue.value).getFullYear() : gettingYearFromDays(parseInt(field.minValue.value, 10)) : 1920;
        const yearOptions = [];
        for(let i = minDate; i <= maxDate; i++){
            yearOptions.push({
                label: i,
                value: i
            });
        }
        return yearOptions.reverse();
    };
    const setDateValue = (date)=>{
        const finalDate = date ? new Date(date).toLocaleDateString("en-US") : new Date(parseInt(year, 10), parseInt(month, 10), parseInt(day, 10)).toLocaleDateString("en-US");
        onChange(finalDate);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isSavedValueSet && year && month && day) {
            setDateValue();
        }
    }, [
        year,
        month,
        day
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isSavedValueSet && htmlDate) {
            setDateValue(htmlDate);
        }
    }, [
        htmlDate
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (!isSavedValueSet && value) {
            const currentDate = value ? new Date(value) : null;
            setDay(currentDate ? currentDate.getDate().toString() : "");
            setMonth(currentDate ? currentDate.getMonth().toString() : "");
            setYear(currentDate ? currentDate.getFullYear().toString() : "");
            setDate(currentDate ? currentDate.toString() : "");
        }
        setTimeout(()=>{
            isSavedValueSet = true;
        }, 100);
    }, [
        value,
        field
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        return ()=>{
            isSavedValueSet = false;
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["date-picker"])} ${className ?? ""} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().desktop)} hidden lg:flex`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().select)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().month)} ${!month ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().empty) : ""}`,
                        onChange: (e)=>setMonth(e.target.value),
                        value: month,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: "",
                                children: translateMonths("MONTH")
                            }),
                            months.map((month, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: month.value,
                                    children: translateMonths(month.label)
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().select)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().day)} ${!day ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().empty) : ""}`,
                        onChange: (e)=>setDay(e.target.value),
                        value: day,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: "",
                                children: translateMonths("DAY")
                            }),
                            new Array(31).fill(0).map((day, index)=>({
                                    label: index + 1,
                                    value: index + 1
                                })).map((day, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: day.value,
                                    children: day.label
                                }, index))
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().select)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().year)} ${!year ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().empty) : ""}`,
                        onChange: (e)=>setYear(e.target.value),
                        value: year,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                value: "",
                                children: translateMonths("YEAR")
                            }),
                            gettingYearOptions().map((year, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                    value: year.value,
                                    children: year.label
                                }, index))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["date-picker"])} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().mobile)} ${className ?? ""} lg:hidden`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        value: value,
                        placeholder: field.placeholder ? field.placeholder : "MM/DD/YYYY",
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["text-input"])}`
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        value: htmlDate,
                        onChange: (e)=>setDate(e.target.value),
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["date-input"])}`,
                        placeholder: field.placeholder ?? undefined,
                        autoComplete: field.autocomplete ?? undefined,
                        type: "date",
                        max: field?.maxValue?.value !== null ? field.maxValue.type === "date" ? new Date(field.maxValue.value).toISOString().split("T")[0] : gettingDateFromDays(parseInt(field.maxValue.value, 10)) : undefined,
                        min: field?.minValue?.value !== null ? field.minValue?.type === "date" ? new Date(field.minValue.value).toISOString().split("T")[0] : gettingDateFromDays(parseInt(field.minValue.value, 10)) : undefined
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 71025:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Input; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/hooks/useDebounce.tsx

function useDebounce(value, delay) {
    const { 0: debouncedValue , 1: setDebouncedValue  } = (0,react.useState)(value);
    (0,react.useEffect)(()=>{
        const timer = setTimeout(()=>setDebouncedValue(value), delay || 500);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}
/* harmony default export */ var hooks_useDebounce = (useDebounce);

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./src/components/shared/form/fields/styles.module.scss
var styles_module = __webpack_require__(14525);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/shared/form/fields/input.tsx





const streetAddressCodename = [
    "streetAddress",
    "streetAddress2"
];
const consentGrantor = {
    email: "consent-grantor-email",
    phoneNumber: "consent-grantor-phone"
};
function Input(props) {
    const { 0: changed , 1: setChanged  } = (0,react.useState)(false);
    const debouncedValue = hooks_useDebounce(props.value ?? "", (props.value ? props.value.length : 0 > 2) ? 10000 : 0);
    const { visitDetails , selectedCountryCode  } = (0,useDomainContext/* useDomainContext */.w)();
    let autoComplete;
    const finalDebouncedValue = (0,react.useMemo)(()=>debouncedValue, [
        debouncedValue
    ]);
    const streetAddressRef = (0,react.useRef)(null);
    const { onChange , onBlur , field , className , type , onKeyDown  } = props;
    const handleGooglePlacesScriptLoaded = ()=>{
        if (streetAddressRef.current !== null) {
            autoComplete = new window.google.maps.places.Autocomplete(streetAddressRef.current, {
                types: [
                    "address"
                ],
                componentRestrictions: {
                    country: selectedCountryCode === "CA" ? "ca" : "us"
                },
                fields: [
                    "address_component",
                    "adr_address",
                    "alt_id",
                    "formatted_address",
                    "geometry",
                    "name", 
                ]
            });
            autoComplete.addListener("place_changed", ()=>handlePlaceSelect());
        }
    };
    const loadGooglePlacesScript = (callback)=>{
        if (document.getElementById("googleStreetAddress")) {
            callback();
            return;
        }
        const script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "googleStreetAddress";
        script.src = `https://maps.googleapis.com/maps/api/js?key=${"AIzaSyAMvrXPGjHZcAH-ro9eCRFpOOm_taXvBGQ"}&libraries=places,geometry&callback=handleGooglePlacesScriptLoaded`;
        document.getElementsByTagName("head")[0].appendChild(script);
    };
    const handlePlaceSelect = ()=>{
        const addressObject = autoComplete.getPlace();
        if (addressObject?.address_components) {
            onChange(//@ts-ignore
            addressObject.address_components[0]["short_name"] + " " + //@ts-ignore
            addressObject.address_components[1]["long_name"]);
        }
    };
    const handleClickEnter = (e)=>{
        if (e.key === "Enter" && streetAddressCodename.includes(field.codeName)) {
            e.preventDefault();
        }
    };
    (0,react.useEffect)(()=>{
        if (streetAddressCodename.includes(field.codeName)) {
            loadGooglePlacesScript(handleGooglePlacesScriptLoaded);
            // @ts-ignore
            window["handleGooglePlacesScriptLoaded"] = handleGooglePlacesScriptLoaded;
        }
    }, []);
    (0,react.useEffect)(()=>{
        if (finalDebouncedValue.length > 2 && changed && !streetAddressCodename.includes(field.codeName)) {
            setChanged(false);
            onBlur();
        }
    }, [
        finalDebouncedValue
    ]);
    const getPlaceHolder = (field, visitDetails)=>{
        if (field.codeName === "zipCode") {
            if (visitDetails?.postalCode) {
                if (visitDetails?.countryCode === "CA") {
                    return selectedCountryCode === "CA" ? `e.g. ${visitDetails?.postalCode} ***` : `e.g. 10010`;
                } else {
                    return selectedCountryCode === "CA" ? "e.g. T2R ***" : `e.g. ${visitDetails?.postalCode}`;
                }
            } else {
                return selectedCountryCode === "CA" ? "e.g. T2R ***" : field.placeholder;
            }
        } else {
            return field.placeholder;
        }
    };
    const getMaxValue = ()=>{
        if (field?.maxValue?.value && field.maxValue.type === "number") return parseInt(field?.maxValue?.value);
        return 250;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            value: props.value ?? "",
            onChange: (e)=>{
                onChange(e.target.value);
                setChanged(true);
            },
            className: `${(styles_module_default()).field} ${(styles_module_default()).input} ${className ?? ""}`,
            placeholder: getPlaceHolder(field, visitDetails) ?? undefined,
            autoComplete: streetAddressCodename.includes(field.codeName) ? "off" : field.autocomplete ?? undefined,
            type: type,
            "data-tf-element-role": consentGrantor[field.codeName] ?? undefined,
            //@ts-ignore
            onBlur: streetAddressCodename.includes(field.codeName) ? undefined : onBlur,
            name: field.codeName ?? undefined,
            maxLength: getMaxValue(),
            ref: streetAddressCodename.includes(field.codeName) ? streetAddressRef : undefined,
            onKeyDown: onKeyDown ? (e)=>{
                onKeyDown(e);
            } : (e)=>{
                handleClickEnter(e);
            },
            id: field.codeName
        })
    });
}


/***/ }),

/***/ 93913:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Checkbox; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function Checkbox({ field , onChange , className , value , primaryColor , ignoreOptionIcons , isSecondServiceForm , searchable =false , colorsConfig , classConfig , errorText , noteText  }) {
    const { 0: show , 1: setShow  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: searchableValue , 1: setSearchableValue  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const { 0: checkboxValue , 1: setCheckboxValue  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(field.defaultValues?.options.filter((option)=>value.includes(option.value)));
    const handleCheckboxChange = (value, remove)=>{
        const tempValue = [
            ...checkboxValue
        ];
        if (remove) {
            onChange(tempValue.filter((option)=>option.value !== value).map((el)=>el.value).join(","));
            return;
        }
        if (tempValue.find((option)=>option.value === value)) {
            onChange(tempValue.filter((option)=>option.value !== value).map((el)=>el.value).join(","));
        } else {
            onChange([
                ...tempValue.map((option)=>option.value),
                value
            ].join(","));
        }
    };
    const renderOptions = ()=>field.defaultValues?.options?.filter((option)=>option.label.toLowerCase().includes(searchableValue.trim().toLowerCase())).map((option)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().option),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                        type: "checkbox",
                        id: `${field.codeName}-${option.value}`,
                        value: option.value,
                        name: field.codeName,
                        //@ts-ignore
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        onClick: (e)=>handleCheckboxChange(e.target.value),
                        checked: !!checkboxValue?.find((el)=>el.value === option.value)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                        htmlFor: `${field.codeName}-${option.value}`,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().box),
                                style: {
                                    borderColor: primaryColor,
                                    backgroundColor: checkboxValue?.find((el)=>el.value === option.value) ? primaryColor : undefined
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                    viewBox: "0,0,50,50",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                        d: "M5 30 L 20 45 L 45 5"
                                    })
                                })
                            }),
                            option?.icon && !ignoreOptionIcons && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "flex items-center mr-2",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: option?.icon?.fullPath,
                                    alt: option.label,
                                    className: "h-8 w-auto max-w-[50px]"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "text-sm flex items-center",
                                style: {
                                    transform: "translateY(1px)"
                                },
                                children: option.label
                            })
                        ]
                    }, option.value)
                ]
            }, option.value));
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setCheckboxValue(field.defaultValues?.options.filter((option)=>value.includes(option.value)));
    }, [
        value
    ]);
    const getLabelsHandler = (value)=>{
        const finalArray = value.split(",").map((el)=>{
            const optionFound = field.defaultValues?.options.find((option)=>option.value === el);
            return optionFound?.label.trim();
        });
        if (finalArray.length > 2) {
            return `${finalArray.slice(0, 1).join(", ")} and others`;
        }
        return finalArray.join(", ");
    };
    const changeInputHandler = (e)=>{
        setSearchableValue(e.target.value);
        setShow((prev)=>{
            if (prev === false) {
                return true;
            }
            return prev;
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative" + ` ${className ?? ""} ${isSecondServiceForm ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["no-background"]) : ""}`,
        tabIndex: 0,
        onBlur: (e)=>{
            if (e.relatedTarget === null) {
                setShow(false);
                setSearchableValue("");
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().multipleSelectLabel)} ${errorText ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().errorBorder) : ""}  ${searchable ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().multipleSelectLabelActive) : value ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().multipleSelectLabelActive) : ""} ${isSecondServiceForm ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().isSecondServiceFormMultipleSelect) : ""}`,
                onClick: ()=>{
                    setShow((prev)=>!prev);
                },
                style: {
                    padding: searchable ? "5px 15px" : "10px 15px"
                },
                children: searchable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                    type: "text",
                    placeholder: field.placeholder ? field.placeholder : "Select Multiple Options",
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().multiSelectInput),
                    value: searchableValue,
                    onChange: changeInputHandler
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: value ? getLabelsHandler(value) : field.placeholder ? field.placeholder : "Select Multiple Options"
                })
            }),
            show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().multipleSelect)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkbox)}`,
                children: renderOptions()?.length === 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "flex justify-center items-center",
                    children: "No Matches Found"
                }) : renderOptions()
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: "pt-2 block",
                children: [
                    errorText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["error-message"])}  ${classConfig?.fieldErrorMessageClassName ?? ""} `,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: errorText
                        })
                    }),
                    noteText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["field-note"])} ${classConfig?.fieldNoteClassName ?? ""} `,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            children: noteText
                        })
                    })
                ]
            }),
            searchable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex gap-3 mt-3 flex-wrap",
                children: checkboxValue.map((option)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "border py-[5px] px-2 text-sm rounded-lg flex gap-3",
                        style: {
                            backgroundColor: colorsConfig?.tagColor ?? primaryColor ?? "black",
                            color: "#fff"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: option.label
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "px-[6px] cursor-pointer",
                                onClick: ()=>{
                                    handleCheckboxChange(option.value, true);
                                },
                                children: "x"
                            })
                        ]
                    }, option.value))
            })
        ]
    });
}


/***/ }),

/***/ 8785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Radio; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/form/fields/styles.module.scss
var styles_module = __webpack_require__(14525);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/svg/magnifyingGlass.tsx


function MagnifyingGlass() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "17",
        fill: "none",
        viewBox: "0 0 17 17",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            fill: "#3C3C43",
            fillOpacity: "0.6",
            d: "M6.917 13.834a6.874 6.874 0 003.797-1.143l3.85 3.859c.254.246.58.369.931.369.73 0 1.266-.571 1.266-1.292 0-.334-.114-.66-.36-.905l-3.824-3.841a6.86 6.86 0 001.257-3.964C13.834 3.111 10.723 0 6.917 0 3.12 0 0 3.111 0 6.917c0 3.806 3.111 6.917 6.917 6.917zm0-1.846c-2.786 0-5.071-2.285-5.071-5.071 0-2.786 2.285-5.071 5.071-5.071 2.786 0 5.071 2.285 5.071 5.071 0 2.786-2.285 5.071-5.071 5.071z"
        })
    });
}
/* harmony default export */ var magnifyingGlass = (MagnifyingGlass);

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/form/fields/radio.tsx
/* eslint-disable @typescript-eslint/no-unsafe-argument */ /* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-return */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ 




function Radio({ field , onClick , value , className , primaryColor , ignoreOptionIcons , isSecondServiceForm , optionSelectedIndex , isLoading , showLoading  }) {
    const { domain , routeConfig  } = (0,useDomainContext/* useDomainContext */.w)();
    const variantConfig = routeConfig?.templateConfig?.variantConfig;
    const { 0: page , 1: setPage  } = (0,react.useState)(0);
    const { 0: searchQuery , 1: setSearchQuery  } = (0,react.useState)("");
    const renderOptions = ()=>{
        const options = checkIfRadioHasMinMaxValue() ? gettingArrayFromMaxMinValues() : field.defaultValues?.options;
        const totalPages = options?.length && field.styles?.perPage ? Math.ceil(options?.length / field.styles?.perPage) : 1;
        const metaIcons = JSON.parse(field.meta?.icons ?? "{}");
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                field?.styles?.withSearch && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: (styles_module_default())["search-wrapper"],
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "text",
                            onChange: (e)=>setSearchQuery(e.target.value?.toLowerCase()),
                            className: (styles_module_default())["radio-search"],
                            placeholder: "Search"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magnifyingGlass, {})
                    ]
                }),
                !options?.filter((x)=>x.label?.toString()?.toLowerCase()?.includes(searchQuery))?.length && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "mx-auto",
                    children: "No Results"
                }),
                (field?.styles?.perPage ? options?.slice(page * field.styles?.perPage, field.styles?.perPage * (page + 1)) : options)?.filter((x)=>{
                    return x?.label?.toString()?.toLowerCase()?.includes(searchQuery);
                })?.map((option, index)=>{
                    const fieldDomainConfig = domain?.config?.formFieldsConfig?.[field?.codeName?.trim()]?.[option?.value?.trim()];
                    const fieldVariantConfig = variantConfig ? variantConfig?.formFieldsConfig?.[field?.codeName?.trim()]?.[option?.value?.trim()] : null;
                    const showIcon = !!((fieldVariantConfig?.icon || fieldDomainConfig?.icon || option?.icon || metaIcons?.[option.label]) && !ignoreOptionIcons);
                    const finalIcon = fieldVariantConfig?.icon || fieldDomainConfig?.icon || (option?.icon?.fullPath) || metaIcons?.[option.label];
                    const labelFromConfig = fieldVariantConfig?.label || fieldDomainConfig?.label;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (styles_module_default()).option,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "radio",
                                id: `${field.codeName}-${index}`,
                                value: option.value,
                                name: field.codeName,
                                // @ts-ignore
                                onClick: (e)=>onClick(e.target.value, `${field.codeName}-${index}`),
                                onChange: ()=>{},
                                checked: isSecondServiceForm ? option.value === value : option.value === value && optionSelectedIndex === `${field.codeName}-${index}`
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                htmlFor: `${field.codeName}-${index}`,
                                className: `${option?.icon && !ignoreOptionIcons ? (styles_module_default()).labelWithIcon : ""} ${showLoading && isLoading ? (styles_module_default()).labelLoading : ""}`,
                                children: option.value === value && showLoading && isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (styles_module_default())["loader-container"],
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (styles_module_default()).loader
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        showIcon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: finalIcon,
                                                alt: (option?.label) ?? "",
                                                className: "h-8 w-auto max-w-[50px]"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: `${option?.icon ? "mt-2" : ""} ${field.styles?.withTooltip ? (styles_module_default())["with-tooltip"] : ""} text-sm`,
                                            children: labelFromConfig || option.label
                                        })
                                    ]
                                })
                            }, index)
                        ]
                    }, index);
                }),
                totalPages > 1 && page + 1 !== totalPages && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: ()=>setPage(page + 1),
                    className: `${(styles_module_default()).option} cursor-pointer`,
                    style: {
                        backgroundColor: primaryColor,
                        color: "white",
                        borderColor: primaryColor
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm",
                        children: "Next"
                    })
                }),
                page ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    onClick: ()=>setPage(page - 1),
                    className: `${(styles_module_default()).option} cursor-pointer`,
                    style: {
                        color: primaryColor,
                        borderColor: primaryColor,
                        backgroundColor: "white"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-sm",
                        children: "Back"
                    })
                }) : null
            ]
        });
    };
    const checkIfRadioHasMinMaxValue = ()=>{
        if (field.maxValue?.value && field.minValue?.value && field.maxValue.type === "number" && field.minValue.type === "number" && field.maxValue.value > field.minValue.value) {
            return true;
        }
        return false;
    };
    const gettingArrayFromMaxMinValues = ()=>{
        const newArray = [];
        for(let i = parseInt(field.minValue?.value, 10); i <= parseInt(field.maxValue?.value, 10); i++){
            newArray.unshift({
                label: i,
                value: `${i}`,
                icon: null
            });
        }
        return newArray;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(styles_module_default()).field} ${(styles_module_default()).radio} ${className ?? ""}`,
        children: renderOptions()
    });
}


/***/ }),

/***/ 63441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Range; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);




const formatters = {
    dollars: _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .parseToDollars */ .Bv,
    percentage: (val)=>`${val}%`
};
function Range({ field , onChange , value , className  }) {
    const minValue = field.minValue?.type === "number" ? field.minValue?.value ?? 0 : 0;
    const maxValue = field.maxValue?.type === "number" ? field.maxValue?.value ?? 0 : 100;
    const step = field.meta?.step ?? 1;
    const labelValue = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (value === minValue && field.meta?.minValueLabel) return field.meta?.minValueLabel;
        if (value === maxValue && field.meta?.maxValueLabel) return field.meta?.maxValueLabel;
        if (field.meta?.rangeValueFormatter === "dollars" || field.meta?.rangeValueFormatter === "percentage") {
            return formatters[field.meta?.rangeValueFormatter](value);
        }
        return value ?? value;
    }, [
        value
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex flex-col justify-center items-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["range-value"]),
                children: labelValue
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                onChange: (e)=>onChange(e.target.value),
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().range)}  ${className ?? ""}`,
                name: field.codeName,
                value: value,
                id: field.codeName,
                type: "range",
                min: minValue,
                max: maxValue,
                step: step
            })
        ]
    });
}


/***/ }),

/***/ 22161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_shared_spinner__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51716);




function Select({ field , onChange , value , className  }) {
    const checkIfSelectHasMinMaxValue = ()=>{
        if (field.maxValue?.value && field.minValue?.value && field.maxValue.type === "number" && field.minValue.type === "number" && field.maxValue.value > field.minValue.value) {
            return true;
        }
        return false;
    };
    const gettingArrayFromMaxMinValues = ()=>{
        const newArray = [];
        for(let i = parseInt(field.minValue?.value, 10); i <= parseInt(field.maxValue?.value, 10); i++){
            newArray.unshift({
                label: i,
                value: i,
                icon: null
            });
        }
        return newArray;
    };
    const options = checkIfSelectHasMinMaxValue() ? gettingArrayFromMaxMinValues() : field.defaultValues?.options;
    const singleOptionValue = options?.length === 1 ? String(options[0].value) : "";
    const isSingleOtherOption = options?.length === 1 && String(options[0]?.label)?.toLowerCase() === "other";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (isSingleOtherOption && value !== singleOptionValue) {
            onChange(singleOptionValue);
        }
    }, [
        isSingleOtherOption,
        onChange,
        singleOptionValue,
        value
    ]);
    const selectValue = isSingleOtherOption ? singleOptionValue : value;
    const renderOptions = ()=>{
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: options?.map((option, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                    value: option.value,
                    children: option.label
                }, index))
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: {
            position: "relative"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("select", {
                    className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().select)} ${!selectValue ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().empty) : ""} ${className ?? ""}`,
                    onChange: (e)=>onChange(e.target.value),
                    name: field.codeName,
                    value: selectValue,
                    disabled: field.fetchingFieldData || isSingleOtherOption,
                    id: field.codeName,
                    children: [
                        field.placeholder && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                            value: "",
                            children: field.placeholder
                        }),
                        renderOptions()
                    ]
                })
            }),
            field.fetchingFieldData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    position: "absolute",
                    right: "50px",
                    top: "10px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_spinner__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: 30,
                    color: "green",
                    success: false
                })
            })
        ]
    });
}


/***/ }),

/***/ 98277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ StreetAddressField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/shared/form/fields/styles.module.scss
var styles_module = __webpack_require__(14525);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 53 modules
var axios = __webpack_require__(29061);
;// CONCATENATED MODULE: ./src/api/searchAddress.ts

const getAddressInfo = async (search, allowedCountry)=>{
    const addressInfo = await axios/* default.get */.Z.get(`/api/getGoogleAddress?address=${search}&allowedCountry=${allowedCountry}`);
    return addressInfo.data;
};

// EXTERNAL MODULE: ./src/components/shared/spinner/index.tsx
var spinner = __webpack_require__(51716);
// EXTERNAL MODULE: ./src/api/index.ts + 19 modules
var api = __webpack_require__(21513);
// EXTERNAL MODULE: ./src/components/shared/form/formNew/components/FormField.tsx + 1 modules
var FormField = __webpack_require__(34024);
// EXTERNAL MODULE: ./src/lib/shared/form.ts + 1 modules
var shared_form = __webpack_require__(198);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
;// CONCATENATED MODULE: ./src/components/shared/form/fields/AddressDetails.tsx








function AddressDetails(props) {
    const { addressContent , expandableFieldList , fieldsData , onChange , setShowAddressDetails , setAddressContent , disableOnBlur ,  } = props;
    const { 0: expFieldsStates , 1: updateExpFieldsStates  } = (0,react.useState)({});
    const { 0: isLoading , 1: setIsLoading  } = (0,react.useState)(false);
    const cancelBtnClicked = (0,react.useRef)(false);
    const displayedFieldsList = expandableFieldList.filter((f)=>f.fieldType !== "hidden");
    async function updateAddress(zipCode) {
        setIsLoading(true);
        const { data , error  } = await (0,api/* getLocationByZipCode */.hR)({
            zipCode
        });
        setIsLoading(false);
        const zipCodeField = (0,sharedUtils/* getZipCodeField */.lF)(expandableFieldList);
        // onExpandableFieldBlur(zipCodeField);
        if (error || !data || !data.stateCode && !data.city) {
            // setError("Invalid Zip Code");
            // onChange(zipCodeField, zipCode);
            updateExpFieldsStates({
                ...expFieldsStates,
                [zipCodeField.codeName]: {
                    ...expFieldsStates[zipCodeField.codeName],
                    value: zipCode,
                    errorMessage: "Invalid Zip Code",
                    valid: false
                }
            });
            return;
        }
        updateExpFieldsStates({
            ...expFieldsStates,
            [zipCodeField.codeName]: {
                ...expFieldsStates[zipCodeField.codeName],
                value: zipCode,
                errorMessage: "",
                valid: true
            }
        });
        onChange(zipCodeField, zipCode);
        setAddressContent(`${data.city}, ${data.stateCode} ${zipCode}`);
        localStorage.setItem("state", JSON.stringify(data.stateCode));
        localStorage.setItem("city", JSON.stringify(data.city));
        localStorage.setItem("zipCode", JSON.stringify(zipCode));
        setShowAddressDetails(false);
        disableOnBlur();
    }
    (0,react.useEffect)(()=>{
        const newExpandableStates = {};
        expandableFieldList.forEach((field)=>{
            newExpandableStates[field.codeName] = {
                ...fieldsData[field.codeName]
            };
        });
        updateExpFieldsStates(newExpandableStates);
    }, [
        fieldsData
    ]);
    const changeExpandableFieldValue = (f, val)=>{
        let newVal = val;
        if (f.mask) {
            newVal = (0,shared_form/* handleFieldMasking */.yr)(f.mask, val);
        }
        onChange(f, val);
        updateExpFieldsStates({
            ...expFieldsStates,
            [f.codeName]: {
                ...expFieldsStates[f.codeName],
                value: newVal
            }
        });
    };
    const handleClickEnter = (e)=>{
        if (e.key === "Enter") {
            e.preventDefault();
            void updateAddress(expFieldsStates["zipCode"]?.value ?? expFieldsStates["toZipCode"]?.value);
        }
    };
    const resetZipCode = ()=>{
        const zipCodeFromStorage = localStorage.getItem("zipCode");
        if (zipCodeFromStorage && zipCodeFromStorage?.length && expFieldsStates && expFieldsStates?.["zipCode"]) {
            // @ts-ignore
            onChange(expFieldsStates["zipCode"], zipCodeFromStorage);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(styles_module_default()).addressDetailsInputs} rounded`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (styles_module_default()).topSection,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: `font-bold text-base  ${(styles_module_default()).addressDetailsTitle}`,
                        children: addressContent
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: `${(styles_module_default()).btnSection}`,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-col",
                        children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (styles_module_default()).getZipCodeLoading,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
                                size: 50,
                                color: "green",
                                success: false,
                                className: (styles_module_default()).getZipCodeLoadSpinner
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                displayedFieldsList.map((f)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "flex flex-col justify-center ",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                                className: `${(styles_module_default()).fieldLabel} text-xs  py-1`,
                                                children: f.label ? `${f.label}` : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                            }),
                                            expFieldsStates[f.codeName] && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormField/* FormField */.W, {
                                                onKeyDown: handleClickEnter,
                                                field: f,
                                                handleFieldBlur: ()=>setTimeout(async ()=>{
                                                        if (!cancelBtnClicked.current) {
                                                            await updateAddress(fieldsData[f.codeName].value);
                                                        }
                                                    }, 500),
                                                isExpandable: true,
                                                handleFieldChange: (f, val)=>{
                                                    changeExpandableFieldValue(f, val);
                                                },
                                                fieldsData: {
                                                    [f.codeName]: {
                                                        ...expFieldsStates[f.codeName]
                                                    }
                                                },
                                                classes: {
                                                    fieldsClassName: {
                                                        all: (styles_module_default()).expandableField
                                                    }
                                                }
                                            })
                                        ]
                                    }, f.codeName)),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: `${(styles_module_default()).btnWrapper} pb-4 pl-0  pt-0`,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        onClickCapture: ()=>{
                                            cancelBtnClicked.current = true;
                                            resetZipCode();
                                            setShowAddressDetails(false);
                                        },
                                        className: (styles_module_default()).btnCancelUpdate,
                                        children: "Cancel"
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
;// CONCATENATED MODULE: ./src/components/shared/form/fields/streetAddress.tsx








const formattedGoogleAddress = (addressObject)=>{
    const newAddressObject = {};
    addressObject.forEach((addressComponent)=>{
        const keyName = addressComponent.types[0];
        newAddressObject[keyName === "postal_code" ? "zipCode" : keyName] = addressComponent;
    });
    return newAddressObject;
};
let isPlaceSelected = false;
function StreetAddressField(props) {
    const { value , onChange , field , fields , className , type , fieldsData , colors , stepStatus , noteIndent ,  } = props;
    let autoComplete;
    const { selectedCountryCode , handleUpdateOffers , routeConfig  } = (0,useDomainContext/* useDomainContext */.w)();
    const synchronizedForms = routeConfig?.templateConfig?.variantConfig?.synchronizedForms;
    const streetAddressRef = (0,react.useRef)(null);
    const { 0: addressContent , 1: setAddressContent  } = (0,react.useState)("");
    const { 0: error , 1: setError  } = (0,react.useState)(null);
    const { 0: inputFieldValue , 1: setInputFieldValue  } = (0,react.useState)(value);
    const { 0: showAddressDetails , 1: setShowAddressDetails  } = (0,react.useState)(false);
    const { 0: loading , 1: setLoading  } = (0,react.useState)(false);
    const { 0: onBlurOff , 1: setDisableOnBlur  } = (0,react.useState)(false);
    const resetFields = (0,react.useMemo)(()=>{
        return Object.keys(JSON.parse(field.meta?.expandable));
    }, [
        field
    ]);
    const zipCodeField = (0,react.useMemo)(()=>{
        return (0,sharedUtils/* getZipCodeField */.lF)(fields);
    }, [
        fields
    ]);
    const inputHandler = (0,react.useCallback)((val)=>{
        setInputFieldValue(val);
        onChange(field, val);
        setTimeout(()=>{
            if (val.trim() === "") {
                setDisableOnBlur(false);
                onChange(field, "");
                const expandableFields = fields.filter((f)=>resetFields.includes(f.codeName));
                expandableFields.forEach((f)=>{
                    onChange(f, "");
                });
                setAddressContent("");
            }
        }, 300);
    }, [
        resetFields
    ]);
    const disableOnBlur = (0,react.useCallback)(()=>{
        setDisableOnBlur(true);
    }, []);
    (0,react.useEffect)(()=>{
        const zipCodeField = (0,sharedUtils/* getZipCodeField */.lF)(fields);
        if (zipCodeField && fieldsData[zipCodeField.codeName]?.value) {
            setTimeout(()=>{
                const state = JSON.parse(localStorage.getItem(`state`));
                const city = JSON.parse(localStorage.getItem(`city`));
                if (state && city) {
                    setAddressContent(`${city}, ${state} ${fieldsData[zipCodeField.codeName]?.value}`);
                }
            }, 300);
        }
    }, [
        fieldsData
    ]);
    (0,react.useEffect)(()=>{
        if (stepStatus === "error" && error) {
            setError("Invalid Street Address");
        }
    }, [
        stepStatus
    ]);
    const handleGooglePlacesScriptLoaded = ()=>{
        if (streetAddressRef.current !== null) {
            autoComplete = new window.google.maps.places.Autocomplete(streetAddressRef.current, {
                types: [
                    "address"
                ],
                componentRestrictions: {
                    country: selectedCountryCode === "CA" ? "ca" : "us"
                },
                fields: [
                    "address_component",
                    "adr_address",
                    "alt_id",
                    "formatted_address",
                    "geometry",
                    "name", 
                ]
            });
            autoComplete.addListener("place_changed", ()=>handlePlaceSelect());
        }
    };
    const loadGooglePlacesScript = (callback)=>{
        if (!synchronizedForms) {
            if (document.getElementById("googleStreetAddress")) {
                callback();
                return;
            }
            const script = document.createElement("script");
            script.type = "text/javascript";
            script.id = "googleStreetAddress";
            script.src = `https://maps.googleapis.com/maps/api/js?key=${"AIzaSyAMvrXPGjHZcAH-ro9eCRFpOOm_taXvBGQ"}&libraries=places,geometry&callback=handleGooglePlacesScriptLoaded`;
            document.getElementsByTagName("head")[0].appendChild(script);
            return;
        }
        // synchronizedForms only: per-instance readiness polling so every form
        // instance on the page wires up its own Autocomplete reliably,
        // regardless of mount order (no reliance on a single global callback).
        // If Google Maps API is already loaded, call callback immediately
        if (window.google?.maps?.places) {
            callback();
            return;
        }
        // Poll for Google Maps API to be ready
        const checkGoogleMaps = ()=>{
            if (window.google?.maps?.places) {
                callback();
            } else {
                setTimeout(checkGoogleMaps, 100);
            }
        };
        // If script element doesn't exist yet, create it
        if (!document.getElementById("googleStreetAddress")) {
            const script1 = document.createElement("script");
            script1.type = "text/javascript";
            script1.id = "googleStreetAddress";
            script1.src = `https://maps.googleapis.com/maps/api/js?key=${"AIzaSyAMvrXPGjHZcAH-ro9eCRFpOOm_taXvBGQ"}&libraries=places,geometry`;
            document.getElementsByTagName("head")[0].appendChild(script1);
        }
        // Start polling (works for both the form that created the script and others)
        checkGoogleMaps();
    };
    function clearFields() {
        const expandableFields = fields.filter((f)=>resetFields.includes(f.codeName));
        expandableFields.forEach((field)=>{
            onChange(field, "");
        });
    }
    async function getAddress(search, searchPart2 = "", fromListAutoComplete = false) {
        setLoading(true);
        const searchKeywords = `${search} ${fromListAutoComplete ? searchPart2 : ""}`.trim();
        const addressResult = await getAddressInfo(encodeURIComponent(searchKeywords), selectedCountryCode === "CA" ? "CA" : "US");
        setLoading(false);
        return addressResult;
    }
    (0,react.useEffect)(()=>{
        setInputFieldValue(value);
    }, [
        value
    ]);
    const isExpandable = (0,react.useMemo)(()=>{
        // extract field meta
        const metaKeys = field.meta ? Object.keys(field.meta) : [];
        // check if field has expandable meta key
        return Array.isArray(metaKeys) && metaKeys.length ? metaKeys[0] === "expandable" ? true : false : false;
    }, [
        field
    ]);
    const expandableList = (0,react.useMemo)(()=>{
        if (isExpandable) {
            const list = Object.keys(JSON.parse(field.meta?.expandable)).filter((key)=>key !== field.codeName);
            return list;
        }
        return [];
    }, [
        field,
        fields,
        isExpandable
    ]);
    const expandableFieldList = (0,react.useMemo)(()=>{
        return fields ? fields.filter((f)=>{
            return expandableList.includes(f.codeName);
        }) : [];
    }, [
        field,
        fields,
        expandableList
    ]);
    const formatAddress = (addressObject)=>{
        if (isExpandable) {
            const expandableFields = field.meta?.expandable ? field.meta.expandable : "";
            let expandableFieldsObject = {};
            if (expandableFields) {
                expandableFieldsObject = JSON.parse(expandableFields);
            }
            const addressComponentsItem = {};
            const fieldsElements = expandableFields ? Object.keys(JSON.parse(expandableFields)) : [];
            const fieldsElementsLength = fieldsElements.length;
            if (fieldsElementsLength) {
                for(let i = 0; i < fieldsElementsLength; i++){
                    const codeName = fieldsElements[i];
                    const format = expandableFieldsObject[codeName].format ?? "long_name";
                    if ((0,sharedUtils/* isStreetAddress */.PS)(codeName)) {
                        addressComponentsItem[codeName] = `${addressObject.street_number?.short_name ?? ""} ${addressObject.route?.long_name ?? ""}`;
                    } else {
                        const addressObjectContent = addressObject[expandableFieldsObject[codeName]?.contentType];
                        addressComponentsItem[codeName] = addressObjectContent ? addressObjectContent[format] : "";
                    }
                }
            }
            // const fieldsLength = fields.length;
            const state = addressObject.administrative_area_level_1?.short_name ?? "";
            const city = addressObject.locality?.short_name ?? "";
            const political = addressObject.political?.short_name ?? "";
            const zipCode = addressObject.zipCode?.short_name ?? "";
            for(let i1 = 0; i1 < fieldsElements.length; i1++){
                const matchedField = fields.find((f)=>f.codeName === fieldsElements[i1]);
                if (matchedField) {
                    onChange(matchedField, addressComponentsItem[fieldsElements[i1]]);
                }
            }
            localStorage.setItem(`state`, JSON.stringify(state));
            localStorage.setItem(`zipCode`, JSON.stringify(zipCode));
            localStorage.setItem(`city`, JSON.stringify(city ? city : political));
            setInputFieldValue(`${addressObject.street_number?.short_name ?? ""} ${addressObject.route?.long_name ?? ""}`);
            setAddressContent(`${city ? city : political}, ${state} ${zipCode}`);
        }
    };
    const validateAddress = (addressInfoResponse)=>{
        if (addressInfoResponse.data.status !== "OK") {
            return false;
        }
        if (addressInfoResponse.data.status === "OK") {
            const streetNumber = addressInfoResponse.data.results[0]?.address_components.find((address)=>address.types.includes("street_number"))?.short_name;
            return streetNumber ? true : false;
        }
    };
    const checkAddress = (search)=>{
        setTimeout((async function() {
            if (isPlaceSelected) {
                isPlaceSelected = false;
                return;
            }
            let validFields = true;
            expandableList.forEach((f)=>validFields = fieldsData[f]?.value !== "" && fieldsData[f]?.valid && validFields);
            validFields = fieldsData[field.codeName].value !== "" && fieldsData[field.codeName].valid && validFields;
            if (!validFields) {
                setAddressContent("");
            }
            // disable calling getAddressInfo on blur
            if (onBlurOff || validFields) {
                setInputFieldValue(search);
                onChange(field, search);
                setError(null);
                return;
            }
            setInputFieldValue(search);
            setShowAddressDetails(false);
            if (search.trim().length === 0) {
                setAddressContent("");
                clearFields();
                return;
            }
            // call the geocoding api
            const addressResult = await getAddress(search);
            const isValidAddress = validateAddress(addressResult);
            if (isValidAddress) {
                const address = formattedGoogleAddress(addressResult.data.results[0]?.address_components);
                formatAddress(address);
                onChange(field, `${address.street_number?.long_name} ${address.route?.long_name}`);
                setError(null);
                // onBlur(field)
                disableOnBlur();
                return;
            }
            onChange(field, search);
            if (zipCodeField) {
                onChange(zipCodeField, "");
            }
            setError("Invalid Street Address");
        }).bind(isPlaceSelected), 450);
    };
    const handlePlaceSelect = async ()=>{
        isPlaceSelected = true;
        setShowAddressDetails(false);
        const placeSelectResults = autoComplete.getPlace();
        if (!placeSelectResults?.address_components) {
            setError("Invalid Street Address");
            if (zipCodeField) {
                onChange(zipCodeField, "");
            }
            return;
        }
        disableOnBlur();
        const address = formattedGoogleAddress(placeSelectResults.address_components);
        const streetNumber = address?.street_number?.short_name ?? "";
        const route = address.route?.long_name ?? "";
        const state = address.administrative_area_level_1?.short_name ?? "";
        const city = address.locality?.short_name ?? "";
        const political = address.political?.short_name ?? "";
        const zipCode = address.zipCode?.short_name ?? "";
        if (state) {
            handleUpdateOffers(state);
        }
        setInputFieldValue(`${streetNumber} ${route}`.trim());
        const addressResult = await getAddress(`${streetNumber} ${route}`, `${city ? city : political ? political : zipCode}, ${state}`, true);
        const isValidAddress = validateAddress(addressResult);
        if (isValidAddress) {
            const address1 = formattedGoogleAddress(addressResult.data.results[0]?.address_components);
            onChange(field, `${streetNumber} ${route}`.trim());
            formatAddress(address1);
            setError(null);
            return;
        }
        // clearFields();
        onChange(field, `${streetNumber} ${route}`.trim());
        if (zipCodeField) {
            onChange(zipCodeField, "");
        }
        setError("Invalid Street Address");
    };
    const handleClickEnter = (e)=>{
        if (e.key === "Enter" && field.fieldType === "streetAddress") {
            e.preventDefault();
        }
    };
    (0,react.useEffect)(()=>{
        if (field.fieldType === "streetAddress") {
            loadGooglePlacesScript(handleGooglePlacesScriptLoaded);
            if (!synchronizedForms) {
                // @ts-ignore
                window["handleGooglePlacesScriptLoaded"] = handleGooglePlacesScriptLoaded;
            }
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: `${(styles_module_default()).streetAddressFieldWrapper}`,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (styles_module_default()).streetAddressField,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        value: inputFieldValue,
                        onChange: (e)=>inputHandler(e.target.value),
                        className: `${(styles_module_default()).field} ${(styles_module_default()).streetField} ${className ?? ""}`,
                        placeholder: field.placeholder ?? undefined,
                        autoComplete: field.fieldType === "streetAddress" ? "off" : field.autocomplete ?? undefined,
                        type: type,
                        //@ts-ignore
                        onBlur: (e)=>checkAddress(e.target.value),
                        name: field.codeName ?? undefined,
                        id: field.codeName,
                        maxLength: field.maxValue ? parseInt(field.maxValue.value, 10) : undefined,
                        ref: field.fieldType === "streetAddress" ? streetAddressRef : undefined,
                        onKeyDown: handleClickEnter
                    }),
                    loading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).loading,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(spinner/* default */.Z, {
                            size: 30,
                            color: "green",
                            success: false
                        })
                    })
                ]
            }),
            fieldsData[field.codeName]?.errorMessage ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(styles_module_default()).error}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: fieldsData[field.codeName]?.errorMessage
                })
            }) : error ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(styles_module_default()).error}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: error
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
            field.note && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: `${(styles_module_default())["field-note"]} ${noteIndent}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: field.note
                })
            }),
            !!(addressContent && expandableFieldList.length && !error && !showAddressDetails) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: `${(styles_module_default()).addressDetails} px-2 py-1 mt-1  text-sm rounded-sm`,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: addressContent
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: ()=>{
                            setShowAddressDetails(!showAddressDetails);
                        },
                        className: `${(styles_module_default())["address-details-button"]}`,
                        style: {
                            color: colors?.primaryColor ?? "#333",
                            borderColor: colors?.primaryColor ?? "#333"
                        },
                        children: showAddressDetails ? "Cancel" : "Change"
                    })
                ]
            }),
            showAddressDetails && expandableFieldList.length && !error && /*#__PURE__*/ (0,jsx_runtime.jsx)(AddressDetails, {
                addressContent: addressContent,
                expandableFieldList: expandableFieldList,
                fieldsData: fieldsData,
                colors: colors,
                onChange: onChange,
                setShowAddressDetails: setShowAddressDetails,
                setAddressContent: setAddressContent,
                disableOnBlur: disableOnBlur
            })
        ]
    });
}


/***/ }),

/***/ 45623:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TextArea; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2__);



function TextArea(props) {
    const { value , onChange , onBlur , field , className  } = props;
    const { maxValue , minValue  } = field;
    const maxLength = maxValue?.type === "number" && maxValue.value != null ? parseInt(String(maxValue.value), 10) : undefined;
    const minLength = minValue?.type === "number" && minValue.value != null ? parseInt(String(minValue.value), 10) : undefined;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", {
        value: value,
        onChange: (e)=>onChange(e.target.value),
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().field)} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_2___default().textarea)} ${className ?? ""}`,
        placeholder: field.placeholder ?? undefined,
        onBlur: (e)=>onBlur(e.target.value),
        maxLength: Number.isNaN(maxLength) ? undefined : maxLength,
        minLength: Number.isNaN(minLength) ? undefined : minLength,
        rows: 5,
        id: field.codeName
    });
}


/***/ }),

/***/ 60195:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ZipCodeExpandable; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var src_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21513);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14525);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75094);
// import useDebounce from "@hooks/useDebounce";





const zipCodeIds = [
    "zipCode",
    "destinationZipCode"
];
function ZipCodeExpandable(props) {
    const { 0: isZipCodeChanged , 1: setZipCodeChanged  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: isSuggestionsListOpened , 1: setSuggestionsListOpened  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: preSelect , 1: setPreSelect  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: suggestions , 1: setSuggestions  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const { 0: selectedZipCode , 1: setZipCode  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const setSelectedZipCode = (zipCode)=>{
        if (zipCode) {
            setZipCode(zipCode);
            sessionStorage.setItem("zipCode", JSON.stringify(zipCode));
        } else {
            setZipCode(null);
            sessionStorage.removeItem("zipCode");
        }
    };
    const { onChange , field , fields , className , value , fieldsData , lightBgColor ,  } = props;
    const expandableFields = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const finalFields = JSON.parse(field.meta?.expandable);
        const data = {};
        // excluding current field
        Object.keys(finalFields).forEach((key)=>{
            if (key !== field.codeName) {
                data[key] = {
                    ...finalFields[key]
                };
            }
        });
        return data;
    }, [
        field
    ]);
    const expandableFieldsPerContentType = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        const finalFields = JSON.parse(field.meta?.expandable);
        const data = {};
        // excluding current field
        Object.keys(finalFields).forEach((key)=>{
            if (key !== field.codeName) {
                const contentType = finalFields[key]?.content;
                data[contentType] = {
                    ...finalFields[key],
                    codeName: key
                };
            }
        });
        return data;
    }, [
        field
    ]);
    const expandableFieldsCodeNames = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>Object.keys(expandableFields), [
        expandableFields
    ]);
    const fieldsToBeUpdated = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        return fields.filter((f)=>expandableFieldsCodeNames.includes(f.codeName));
    }, [
        fields
    ]);
    const activeZipCode = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (isZipCodeChanged && suggestions.length === 0) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
        let isDataExist = false;
        Object.keys(fieldsData).forEach((k)=>{
            if (expandableFieldsCodeNames.includes(k) && fieldsData[k].value) {
                isDataExist = true;
            }
        });
        const className = `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().addressDetails)} px-2 py-1 mt-1  text-sm rounded-sm ${field.meta?.zipcodeDetailsPosition === "inside" ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["zipcode-details-inside"]) : ""}`;
        if (isDataExist && fieldsData[field.codeName]?.value) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                className: className,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            fieldsData[expandableFieldsPerContentType?.city?.codeName]?.value,
                            ",",
                            " ",
                            fieldsData[expandableFieldsPerContentType?.stateCode?.codeName]?.value
                        ]
                    }),
                    " "
                ]
            });
        }
        if (selectedZipCode) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: className,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    children: [
                        selectedZipCode?.city,
                        ", ",
                        selectedZipCode.stateCode
                    ]
                })
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }, [
        fieldsData,
        expandableFieldsCodeNames,
        field,
        expandableFields,
        expandableFieldsPerContentType,
        selectedZipCode, 
    ]);
    const setExpandableFieldsValues = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((setData = true)=>{
        // update Expandable Fields values
        fieldsToBeUpdated.forEach((f)=>{
            onChange(f, selectedZipCode ? setData ? selectedZipCode[expandableFields[f.codeName].content] : "" : "");
        });
    }, [
        selectedZipCode,
        fieldsToBeUpdated
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (selectedZipCode) {
            setExpandableFieldsValues();
        }
    }, [
        selectedZipCode
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const clickOutside = (event)=>{
            if (!event.target.closest(`.${field.codeName}-autocomplete`)) {
                setSuggestionsListOpened(false);
            }
        };
        document.addEventListener("click", clickOutside, false);
        return ()=>document.removeEventListener("click", clickOutside);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const getData = setTimeout(async ()=>{
            if (!isZipCodeChanged) {
                return;
            }
            if (value?.length >= 3 && !preSelect || value?.length < 5 && preSelect) {
                const { data: result , error  } = await (0,src_api__WEBPACK_IMPORTED_MODULE_2__/* .getZipCodeSuggestions */ .iq)({
                    zipCode: value
                });
                if (error) {
                    return;
                }
                setSuggestions(result);
                if (result?.length > 1) {
                    setSuggestionsListOpened(true);
                } else {
                    setSuggestionsListOpened(false);
                }
                if (result?.length === 1) {
                    setSelectedZipCode(result[0]);
                    setPreSelect(true);
                } else {
                    setSelectedZipCode(null);
                    setPreSelect(false);
                }
            }
            if (value?.length === 5) {
                setPreSelect(false);
            }
            if (value?.length === 0) {
                setSuggestions([]);
                setSelectedZipCode(null);
            }
        }, 250);
        return ()=>clearTimeout(getData);
    }, [
        value
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        async function getInitialData() {
            try {
                const response = await (0,src_api__WEBPACK_IMPORTED_MODULE_2__/* .getZipCodeSuggestions */ .iq)({
                    zipCode: fieldsData[field.codeName].value
                });
                setSelectedZipCode(response.data[0]);
            } catch (e) {
            //
            }
        }
        if (fieldsData[field.codeName].value && fieldsData[field.codeName].value.length === 5) {
            let isDataExist = false;
            Object.keys(fieldsData).forEach((k)=>{
                if (expandableFieldsCodeNames.includes(k) && fieldsData[k].value) {
                    isDataExist = true;
                }
            });
            if (!isDataExist) {
                const zipCodeFromSession = sessionStorage.getItem("zipCode");
                if (!zipCodeFromSession) {
                    void getInitialData();
                } else {
                    setSelectedZipCode(JSON.parse(zipCodeFromSession));
                }
            }
        }
    }, []);
    const selectZipCode = (suggestion, index)=>{
        setSelectedZipCode({
            ...suggestion,
            index
        });
        onChange(field, suggestion.zipCode);
        const fieldsKeyedObjects = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_3__/* .arrayToKeyedObject */ .sB)(fields, "codeName");
        // fill expandableFields values
        Object.keys(expandableFields).forEach((k)=>{
            onChange(fieldsKeyedObjects[k], suggestion[expandableFields[k].content]);
        });
        setPreSelect(true);
        setSuggestionsListOpened(false);
    };
    const suggestionsList = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (value.length === 0 || value.length > 5) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
        }
        if (suggestions.length > 1 && !selectedZipCode) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                id: "suggestions-list",
                className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().suggestionsWrapper)} ${field.codeName}-autocomplete`,
                children: suggestions.map((suggestion, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().suggestion)} hover:font-bold text-sm`,
                        onClick: ()=>{
                            selectZipCode(suggestion, index);
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: suggestion.zipCode
                            }),
                            " -",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: suggestion.city
                            }),
                            ",",
                            " ",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                children: suggestion.stateCode
                            })
                        ]
                    }, index))
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    }, [
        suggestions,
        value,
        selectedZipCode,
        preSelect,
        fieldsData,
        expandableFieldsCodeNames, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: `relative w-full ${className}`,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `flex items-stretch ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().inputWrapper)}`,
                children: [
                    field.meta?.customLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().customLabel)} `,
                        style: {
                            backgroundColor: lightBgColor ?? "#efefef"
                        },
                        children: field.meta?.customLabel
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `w-full`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            value: value,
                            onChange: (e)=>{
                                onChange(field, e.target.value);
                                setZipCodeChanged(true);
                            },
                            onBlur: (e)=>{
                                if (zipCodeIds.includes(e.relatedTarget?.attributes.getNamedItem("id")?.value)) {
                                    setSuggestionsListOpened(false);
                                }
                            },
                            autoComplete: "off",
                            role: "presentation",
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().field)} ${className ?? ""} w-full`,
                            placeholder: field.placeholder ?? undefined,
                            type: "tel",
                            name: field.codeName ?? undefined,
                            id: field.codeName
                        })
                    })
                ]
            }),
            fieldsData[field.codeName].valid && activeZipCode,
            isSuggestionsListOpened && suggestionsList
        ]
    });
}


/***/ }),

/***/ 34024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "W": function() { return /* binding */ FormField; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useDomainContext.tsx
var useDomainContext = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/components/shared/form/fields/input.tsx + 1 modules
var input = __webpack_require__(71025);
// EXTERNAL MODULE: ./src/components/shared/form/styles.module.scss
var styles_module = __webpack_require__(67408);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
// EXTERNAL MODULE: ./src/components/shared/form/fields/streetAddress.tsx + 2 modules
var streetAddress = __webpack_require__(98277);
// EXTERNAL MODULE: ./src/components/shared/form/fields/zipCodeExpandable.tsx
var zipCodeExpandable = __webpack_require__(60195);
// EXTERNAL MODULE: ./src/components/shared/form/fields/datePicker.tsx
var datePicker = __webpack_require__(83354);
// EXTERNAL MODULE: ./src/components/shared/form/fields/textarea.tsx
var fields_textarea = __webpack_require__(45623);
// EXTERNAL MODULE: ./src/components/shared/form/fields/select.tsx
var fields_select = __webpack_require__(22161);
// EXTERNAL MODULE: ./src/components/shared/form/fields/multipleSelect.tsx
var multipleSelect = __webpack_require__(93913);
// EXTERNAL MODULE: ./src/components/shared/form/fields/calculatedYears.tsx
var calculatedYears = __webpack_require__(63697);
// EXTERNAL MODULE: ./src/components/shared/form/fields/radio.tsx + 1 modules
var fields_radio = __webpack_require__(8785);
// EXTERNAL MODULE: ./src/components/shared/form/fields/range.tsx
var range = __webpack_require__(63441);
// EXTERNAL MODULE: ./src/components/shared/form/fields/checkbox.tsx
var fields_checkbox = __webpack_require__(87217);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/lib/shared/form.ts + 1 modules
var shared_form = __webpack_require__(198);
// EXTERNAL MODULE: ./node_modules/rc-tooltip/es/index.js + 84 modules
var es = __webpack_require__(70362);
// EXTERNAL MODULE: ./src/components/svg/tooltipIcon.tsx
var tooltipIcon = __webpack_require__(88736);
;// CONCATENATED MODULE: ./src/components/shared/form/fields/hidden.tsx


function Hidden({ field , value  }) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
            name: field.codeName,
            value: value,
            id: field.codeName,
            type: "hidden"
        })
    });
}

// EXTERNAL MODULE: ./src/lib/capitalizeFirstLetter.ts
var capitalizeFirstLetter = __webpack_require__(8712);
// EXTERNAL MODULE: ./src/lib/sharedUtils.ts
var sharedUtils = __webpack_require__(75094);
// EXTERNAL MODULE: ./src/api/callEvent.ts
var callEvent = __webpack_require__(96419);
// EXTERNAL MODULE: ./src/components/shared/loader/index.tsx
var loader = __webpack_require__(95301);
// EXTERNAL MODULE: ./src/components/svg/arrowRightIcon.tsx
var arrowRightIcon = __webpack_require__(78963);
;// CONCATENATED MODULE: ./src/components/shared/form/formNew/components/FormField.tsx
// needs refactor

























const FormField = (props)=>{
    const { handleFieldBlur , handleFieldChange , onKeyDown , asTitle , fieldsData , field , fields , classes , colors , currentStep , stepStatus , formId , isExpandable , ignoreOptionIcons , isSecondServiceForm , searchableMultiSelect , singleQuestion , isLoading , mergeInputWithSubmitOnFirstStep ,  } = props;
    const { form , selectedCountryCode , updateSelectedCountryCode , locale , domain , buyerPhoneNumber ,  } = (0,useDomainContext/* useDomainContext */.w)();
    const { query  } = (0,router.useRouter)();
    const getFieldType = ()=>{
        const metaKeys = field.meta ? Object.keys(field.meta) : [];
        // check if field has expandable meta key
        const isExpandableField = Array.isArray(metaKeys) && metaKeys.length ? metaKeys.includes("expandable") ? true : false : false;
        if (isExpandableField && field.fieldType !== "hidden") {
            const expandableFields = JSON.parse(field.meta?.expandable ?? "");
            const keys = Object.keys(expandableFields);
            for(let i = 0; i < keys.length; i++){
                if (keys[i] === field.codeName) {
                    field.fieldType = expandableFields[keys[i]]?.contentType;
                    return expandableFields[keys[i]].contentType;
                }
            }
            return field.fieldType;
        }
        return field.fieldType;
    };
    const getFieldErrorMessage = ()=>{
        if (selectedCountryCode === "CA" && field.codeName === "zipCode" && !fieldState.valid) {
            return locale === "en" ? field.meta?.postalCodeErrorMsg ?? "Enter a Valid Postal Code" : field.meta?.postalCodeErrorMsgEs ?? "Ingrese un c\xf3digo postal v\xe1lido";
        } else {
            return fieldState?.errorMessage;
        }
    };
    const decodeNote = (note)=>{
        if (note) {
            const { meta  } = field;
            if (meta && meta?.showCharCount && meta?.showCharCount === "true") {
                return note.replace(/\[charCount\]/gi, (parseInt(field.maxValue?.value) - fieldState.value.length).toString());
            }
            return note;
        }
        return note;
    };
    const getFieldLabel = ()=>{
        if (buyerPhoneNumber) {
            return "Don't wait—call now!";
        }
        if (selectedCountryCode === "CA" && field.codeName === "zipCode") {
            return field.meta?.canadianLabel ?? "Postal Code";
        } else {
            return field.label;
        }
    };
    const fieldState = fieldsData[field.codeName];
    const fieldErrorMessage = (0,capitalizeFirstLetter/* capitalizeFirstLetter */.f)(getFieldErrorMessage() ?? "");
    const renderErrorMessage = ()=>{
        if (!fieldErrorMessage) return null;
        if (!fieldState?.isRejectedAnswerResult) {
            return fieldErrorMessage;
        }
        const phoneRegex = /(\+?\d[\d\s().-]{7,}\d)/g;
        const isPhonePart = (part)=>/^(\+?\d[\d\s().-]{7,}\d)$/.test(part);
        return fieldErrorMessage.split(phoneRegex).map((part, index)=>{
            if (!part) return null;
            if (isPhonePart(part)) {
                const hrefPhone = part.replace(/[^\d+]/g, "");
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: `tel:${hrefPhone}`,
                    className: "underline",
                    children: part
                }, `${part}-${index}`);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: part
            }, `${part}-${index}`);
        });
    };
    const gettingField = ()=>{
        const type = getFieldType();
        switch(type){
            case "text":
            case "email":
            case "number":
            case "tel":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(input/* default */.Z, {
                    field: field,
                    onChange: (val)=>handleFieldChange(field, val),
                    onBlur: ()=>!isSecondServiceForm ? handleFieldBlur(field) : null,
                    value: fieldState?.value,
                    type: type,
                    className: `${classes?.fieldsClassName?.input ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                    onKeyDown: onKeyDown,
                    fieldsData: fieldsData
                });
            case "streetAddress":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(streetAddress/* default */.Z, {
                    field: field,
                    fields: fields,
                    onChange: (field, val)=>handleFieldChange(field, val),
                    onBlur: (f)=>!isSecondServiceForm ? handleFieldBlur(f) : null,
                    value: fieldState?.value,
                    type: type,
                    className: `${classes?.fieldsClassName?.streetAddress ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                    currentStep: currentStep,
                    fieldsData: fieldsData,
                    colors: colors,
                    stepStatus: stepStatus,
                    noteIndent: `${isInputField ? classes?.noteIndent : ""}`
                });
            case "zipCodeExpandable":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(zipCodeExpandable/* default */.Z, {
                    field: field,
                    fields: fields ?? [],
                    onChange: (field, val)=>handleFieldChange(field, val),
                    value: fieldState?.value,
                    type: type,
                    className: `${classes?.fieldsClassName?.all ?? ""} ${classes?.fieldsClassName?.zipcodeExpandable ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                    onKeyDown: onKeyDown,
                    fieldsData: fieldsData,
                    lightBgColor: colors.lightPrimaryColor
                });
            case "date":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(datePicker/* default */.Z, {
                    field: field,
                    onChange: (val)=>handleFieldChange(field, val),
                    onBlur: ()=>handleFieldBlur(field),
                    value: fieldState?.value,
                    className: ` ${classes?.fieldsClassName?.date ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`
                });
            case "textarea":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_textarea/* default */.Z, {
                    field: field,
                    onChange: (val)=>handleFieldChange(field, val),
                    onBlur: ()=>handleFieldBlur(field),
                    value: fieldState?.value,
                    className: `${classes?.fieldsClassName?.textarea ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`
                });
            case "select":
                {
                    if (singleQuestion) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_radio/* default */.Z, {
                            onClick: (val, optionSelectedIndex)=>{
                                handleFieldChange(field, val, optionSelectedIndex);
                            },
                            onChange: (val)=>handleFieldChange(field, val),
                            field: field,
                            value: fieldState?.value,
                            optionSelectedIndex: fieldState?.optionSelectedIndex,
                            className: `${classes?.fieldsClassName?.radio ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                            primaryColor: colors.primaryColor,
                            ignoreOptionIcons: ignoreOptionIcons,
                            formId: formId,
                            isSecondServiceForm: isSecondServiceForm,
                            isLoading: isLoading,
                            showLoading: true
                        });
                    }
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_select/* default */.Z, {
                        field: field,
                        onChange: (val)=>handleFieldChange(field, val),
                        value: fieldState?.value,
                        className: `${classes?.fieldsClassName?.select ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`
                    });
                }
            case "multiSelect":
            case "multipleSelect":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(multipleSelect/* default */.Z, {
                    onChange: (val)=>handleFieldChange(field, val),
                    field: field,
                    value: fieldState?.value,
                    className: `${isSecondServiceForm ? classes?.fieldsClassName?.checkbox ?? "" : classes?.fieldsClassName?.multiSelect ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                    isSecondServiceForm: isSecondServiceForm,
                    primaryColor: colors.primaryColor,
                    ignoreOptionIcons: ignoreOptionIcons,
                    searchable: searchableMultiSelect,
                    colorsConfig: {
                        tagColor: colors.multiSelectTagColor
                    },
                    classConfig: {
                        fieldErrorMessageClassName: classes?.fieldErrorMessageClassName,
                        fieldNoteClassName: classes?.fieldNoteClassName
                    },
                    errorText: (0,capitalizeFirstLetter/* capitalizeFirstLetter */.f)(getFieldErrorMessage()),
                    noteText: decodeNote(field.note)
                });
            case "calculatedYears":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(calculatedYears/* default */.Z, {
                    field: field,
                    onChange: (val)=>handleFieldChange(field, val),
                    value: fieldState?.value,
                    className: `${classes?.fieldsClassName?.select ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`
                });
            case "radio":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_radio/* default */.Z, {
                    onClick: (val, optionSelectedIndex)=>{
                        handleFieldChange(field, val, optionSelectedIndex);
                    },
                    onChange: (val)=>handleFieldChange(field, val),
                    field: field,
                    value: fieldState?.value,
                    optionSelectedIndex: fieldState?.optionSelectedIndex,
                    className: `${classes?.fieldsClassName?.radio ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                    primaryColor: colors.primaryColor,
                    ignoreOptionIcons: ignoreOptionIcons,
                    formId: formId,
                    isSecondServiceForm: isSecondServiceForm
                });
            case "checkbox":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(fields_checkbox/* default */.Z, {
                    onChange: (val)=>handleFieldChange(field, val),
                    field: field,
                    value: fieldState?.value,
                    className: `${classes?.fieldsClassName?.checkbox ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`,
                    primaryColor: colors.primaryColor,
                    ignoreOptionIcons: ignoreOptionIcons
                });
            case "range":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(range/* default */.Z, {
                    field: field,
                    onChange: (val)=>handleFieldChange(field, val),
                    // onBlur={() => handleFieldBlur(field)}
                    value: fieldState?.value,
                    className: `${classes?.fieldsClassName?.range ?? ""} ${classes?.fieldsClassName?.all ?? ""} ${isSecondServiceForm ? (styles_module_default()).secondServiceField : ""}`
                });
            case "hidden":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden, {
                    field: field,
                    value: fieldState?.value
                });
        }
    };
    (0,react.useEffect)(()=>{
        if (!(0,shared_form/* canShowFieldAfterDependency */.bw)(field, fieldsData) && fieldState.value !== "") handleFieldChange(field, "");
    }, [
        fieldsData
    ]);
    const fieldDescription = (0,react.useMemo)(()=>{
        const fieldDesc = field.meta?.fieldDescription;
        return fieldDesc ?? null;
    }, [
        field
    ]);
    const isInputField = (0,react.useMemo)(()=>{
        const type = getFieldType();
        switch(type){
            case "text":
            case "email":
            case "number":
            case "tel":
            case "streetAddress":
                return true;
            default:
                return false;
        }
    }, []);
    if (buyerPhoneNumber) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: `tel:${buyerPhoneNumber}`,
                onClick: ()=>{
                    void (0,callEvent/* callEvent */.d)({
                        event: "Call",
                        phoneNumber: buyerPhoneNumber
                    });
                },
                className: `${(styles_module_default())["submit-button"]} ${classes?.formButtonClassName ?? ""} ${(styles_module_default()).PhoneNumberBtn}`,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: (0,sharedUtils/* formatPhoneNumber */.un)(buyerPhoneNumber)
                })
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: `${(styles_module_default())["form-field"]} ${field.conditionalLogic && field.conditionalLogic.isActive && !field.meta?.hideConditionalLogicClass ? (styles_module_default()).conditionalLogic : ""} ${!fieldState?.valid ? (styles_module_default()).error : ""} ${classes?.formFieldClassName ?? ""} ${field.fieldType === "hidden" ? (styles_module_default()).hidden : ""}`,
        ref: (node)=>{
            if (node) {
                if (!(0,shared_form/* canShowFieldAfterDependency */.bw)(field, fieldsData)) {
                    node.style.setProperty("display", "none", "important");
                } else {
                    node.style.setProperty("display", null);
                }
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                field.label && !isExpandable && /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                    className: `${(styles_module_default())["field-label"]} ${classes?.formFieldLabelClassName ?? ""} ${asTitle || field.meta?.hideConditionalLogicClass ? `${(styles_module_default())["as-title"]} ${classes?.labelAsTitleClassName ?? ""}` : `${isInputField ? (classes?.roundedLabelShift) ? (classes?.roundedLabelShift) : "" : ""}`}`,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: getFieldLabel()
                        }),
                        field.meta?.tooltip && !isExpandable && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* default */.Z, {
                            placement: "bottom",
                            overlay: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: field.meta.tooltip
                            }),
                            trigger: [
                                "hover"
                            ],
                            overlayClassName: (styles_module_default()).tooltip,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default())["tooltip-icon"],
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tooltipIcon/* default */.Z, {})
                            })
                        }),
                        fieldDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(styles_module_default())["field-description"]} ${classes?.formFieldDescriptionClassName ?? ""}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: fieldDescription
                            })
                        })
                    ]
                }),
                mergeInputWithSubmitOnFirstStep && currentStep === 0 && fields?.length === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (styles_module_default())["input-wrapper-with-submit"],
                    children: [
                        gettingField(),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "submit",
                            className: (styles_module_default())["circular-submit-button"],
                            style: {
                                backgroundColor: colors.primaryColor || "var(--global-form-buttons-background-color)",
                                "--modal-button-text-color": colors.modalButtonTextColor || ""
                            },
                            disabled: isLoading,
                            children: isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {
                                    size: 30
                                })
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: `${(styles_module_default()).arrow}`,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrowRightIcon/* default */.Z, {})
                            })
                        })
                    ]
                }) : gettingField(),
                !query?.countryCode && selectedCountryCode && field.codeName === "zipCode" && form?.supportedCountries?.find((item)=>item.value === selectedCountryCode) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "text-xs mt-1 country-code-disclaimer",
                    style: {
                        color: domain.config?.countryCodeColors?.textColor ?? "black"
                    },
                    children: [
                        "Your current location is set to",
                        " ",
                        selectedCountryCode === "US" ? "United States" : "Canada",
                        ",",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "text-[#15B4F9] hover:underline cursor-pointer ",
                            style: {
                                color: domain.config?.countryCodeColors?.clickHereColor ?? "#15B4F9"
                            },
                            onClick: ()=>{
                                if (selectedCountryCode === "CA") {
                                    updateSelectedCountryCode("US");
                                    return;
                                }
                                updateSelectedCountryCode("CA");
                            },
                            children: "Click here"
                        }),
                        " ",
                        "to change your location to",
                        " ",
                        selectedCountryCode === "US" ? "Canada" : "United States",
                        "."
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
                field.fieldType !== "streetAddress" && field.fieldType !== "multiSelect" && field.fieldType !== "multipleSelect" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        fieldErrorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(styles_module_default())["error-message"]} ${classes?.fieldErrorMessageClassName ?? ""} ${field.codeName === "date" ? "w-[90%] md:w-[54%]  mx-auto" : ""} ${fieldState.isRejectedAnswerResult ? (styles_module_default()).rejectedAnswerErrorContainer : ""}`,
                            children: fieldState.isRejectedAnswerResult ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (styles_module_default()).rejectedAnswerErrorMessage,
                                children: field.fieldType === "radio" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: renderErrorMessage()
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: renderErrorMessage()
                                })
                            }) : field.fieldType !== "radio" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: renderErrorMessage()
                            }) : null
                        }),
                        field.note && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: `${(styles_module_default())["field-note"]} ${classes?.fieldNoteClassName ?? ""} ${isInputField ? classes?.noteIndent : ""}`,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: decodeNote(field.note)
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 59067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ decodeFieldsFromText; }
/* harmony export */ });
// Matches placeholders like ${firstName} globally in a text string.
const DYNAMIC_FIELD_TOKEN_REGEX = /\${([^}]*)}/g;
const decodeFieldsFromText = (text, fieldsState)=>{
    let clonedText = text;
    const dynamicStrings = text?.match(DYNAMIC_FIELD_TOKEN_REGEX);
    dynamicStrings?.forEach((item)=>{
        if (fieldsState?.[item.replace("${", "").replace("}", "")]?.value) {
            const temp = clonedText.replace(item, fieldsState[item.replace("${", "").replace("}", "")]?.value);
            clonedText = temp;
        }
    });
    return clonedText;
};


/***/ }),

/***/ 22366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OffersInForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73504);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _hooks_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70211);
/* harmony import */ var src_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21513);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88737);







function OffersInForm({ offer , classes , shape  }) {
    const { domain , domainNameTranslation  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_5__/* .useDomainContext */ .w)();
    const phoneNumber = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .getPhoneNumber */ .ly)(offer);
    const { translate  } = (0,_hooks_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* .useTranslation */ .$)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            shape === "v2" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: ` ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().orStyles)} ${classes?.orStyle || ""} flex gap-2 justify-center items-center  mx-auto my-4`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "border-dashed border-t-2 block w-[200px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            " ",
                            translate("OR") === "OR" ? "Or" : translate("OR")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "border-dashed border-t-2 block w-[200px]"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `text-center  p-3   ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().container)} ${classes?.containerStyle || ""}`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        className: "font-bold text-base sm:text-lg leading-6 mb-1",
                        children: translate("CALL_US_IMMEDIATE") === "CALL_US_IMMEDIATE" ? domain?.translations?.[`${domainNameTranslation}_CALL_US_IMMEDIATE`] ?? "Call us Now for Immediate Assistance. It is 100% Free!" : translate("CALL_US_IMMEDIATE")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                        href: `tel:${phoneNumber}`,
                        onClick: ()=>{
                            if (phoneNumber) {
                                void (0,src_api__WEBPACK_IMPORTED_MODULE_4__/* .callEvent */ .dr)({
                                    event: "Call",
                                    phoneNumber: phoneNumber
                                });
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: `ltrStyle underline font-bold text-lg sm:text-xl leading-9 ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().linkColor)}`,
                            children: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .formatPhoneNumber */ .un)(phoneNumber)
                        })
                    })
                ]
            }),
            shape === "v1" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${classes?.orStyle || ""} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_6___default().orStyles)}  flex gap-2 justify-center items-center  mx-auto my-4`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "border-dashed border-t-2 block w-[200px]"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            " ",
                            translate("OR") === "OR" ? "Or" : translate("OR")
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "border-dashed border-t-2 block w-[200px]"
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 6515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ MissingFieldsHeadline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50890);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _lib_shared_lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90969);





const defaultText = "<h1>Almost There!</h1><p>Thank you for your interest! Please provide your ${codeName} below to complete your inquiry and receive a free quote.</p>";
function MissingFieldsHeadline() {
    const { domain , category , visitDetails , piiCompletionData  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const textBlock = domain?.textBlocks?.find((textBlock)=>textBlock.position === "pii-completion-missing-field");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center flex-col",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["pii-missing-field-headline"]),
            dangerouslySetInnerHTML: {
                __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .replacePlaceholders */ .wT)(textBlock?.text || defaultText, {
                    category: category?.name,
                    region: visitDetails?.region
                }).replace("${codeName}", piiCompletionData?.missingFields.length === 1 ? (0,_lib_shared_lodash__WEBPACK_IMPORTED_MODULE_4__/* .lowerCase */ .vl)(piiCompletionData?.missingFields[0]) : "information")
            }
        })
    });
}


/***/ }),

/***/ 50752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OtherFieldsHeadline; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50890);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75094);
/* harmony import */ var _lib_shared_lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90969);





const defaultText = `
    <p>
        Please confirm your details to receive your free quote.
    </p>
`;
function OtherFieldsHeadline() {
    const { domain , category , visitDetails , piiCompletionData  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const textBlock = domain?.textBlocks?.find((textBlock)=>textBlock.position === "pii-completion-other-fields");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex items-center flex-col",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["pii-other-fields-headline"]),
            dangerouslySetInnerHTML: {
                __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_2__/* .replacePlaceholders */ .wT)(textBlock?.text || defaultText, {
                    category: category?.name,
                    region: visitDetails?.region
                }).replace("${codeName}", (0,_lib_shared_lodash__WEBPACK_IMPORTED_MODULE_4__/* .startCase */ .fl)(piiCompletionData?.missingFields[0]) ?? "information")
            }
        })
    });
}


/***/ }),

/***/ 91354:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProgressBar; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90796);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3__);




function ProgressBar({ total , current , className , color , backgroundColor , shift =0 , showStepNumberOnly =false , mode ="continuous" , title ="" , titleIcon , activeSegmentClassName =""  }) {
    const progress = (current + shift) / (total + shift - 1);
    const progressPercentage = Math.round(progress * 100);
    const hideStepsNumber = current + shift + 1 > total + shift - 1;
    if (mode === "steps") {
        const activeIndex = current + shift;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["top-progress-bar"])} ${className} ${activeIndex >= total - 1 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success) : ""}`,
            style: {
                backgroundColor
            },
            children: [
                (title || titleIcon) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["progress-title"]),
                    children: [
                        titleIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["title-icon"]),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: titleIcon,
                                alt: title ?? "form icon",
                                height: "50px",
                                width: "50px"
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().title),
                            children: title
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().segments),
                    children: Array.from({
                        length: total
                    }).map((_, index)=>{
                        const isActive = index <= activeIndex;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().segment)} ${isActive ? `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["active-segment"])} progressStepActive ${activeSegmentClassName}` : (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["inactive-segment"])}`
                        }, index);
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["progress-bar"])} ${className} ${progressPercentage === 100 ? (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().success) : ""}`,
        children: !showStepNumberOnly ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: {
                        left: progressPercentage ? `${progressPercentage}%` : 0,
                        transform: "translateX(-50%)",
                        background: color
                    },
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().percentage),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            className: "text-xs",
                            children: [
                                progressPercentage,
                                "%"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                borderBottomColor: color
                            },
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().arrow)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default().bar),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            width: `${progressPercentage}%`,
                            background: color
                        }
                    })
                })
            ]
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: !hideStepsNumber && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["step-number"]),
                children: [
                    current + shift + 1,
                    " of ",
                    total + shift - 1
                ]
            })
        })
    });
}


/***/ }),

/***/ 70790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SecondServiceForms; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88737);
/* harmony import */ var _hooks_useFormContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21465);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_api__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(21513);
/* harmony import */ var _components_shared_form__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96119);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(83718);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _components_shared_spinner__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51716);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(75094);









const initialSecondServiceFormsState = {
    loading: false,
    selectedServiceForm: null,
    selectedServiceSlug: [],
    tags: {},
    error: null,
    goToThankYou: false
};
const reducer = (state, action)=>{
    switch(action.type){
        case "REMOVE_SERVICE":
            {
                const selectedServiceSlug = [
                    ...state.selectedServiceSlug
                ];
                selectedServiceSlug.splice(state.selectedServiceSlug.findIndex((elem)=>elem === state.tags[action.payload.tag].slug), 1);
                const newTag = {
                    ...state.tags
                };
                newTag[action.payload.tag].active = false;
                return {
                    ...state,
                    selectedServiceSlug: selectedServiceSlug,
                    tags: newTag
                };
            }
        case "SELECT_SERVICE":
            {
                const newTag1 = {
                    ...state.tags
                };
                newTag1[action.payload.tag].active = true;
                const selectedServiceSlug1 = state.selectedServiceSlug.includes(state.tags[action.payload.tag].slug) ? [
                    ...state.selectedServiceSlug
                ] : [
                    ...state.selectedServiceSlug,
                    state.tags[action.payload.tag].slug, 
                ];
                return {
                    ...state,
                    selectedServiceSlug: selectedServiceSlug1,
                    tags: newTag1
                };
            }
        case "INITIATE_SERVICES":
            {
                const slugs = Object.keys(action.payload.tags).map((tag)=>action.payload.tags[tag].slug);
                return {
                    ...state,
                    tags: action.payload.tags,
                    selectedServiceSlug: slugs
                };
            }
        case "SET_LOADING":
            {
                return {
                    ...state,
                    loading: action.payload
                };
            }
        case "SELECT_SERVICE_ERROR":
            return {
                ...state,
                loading: false,
                error: action.payload,
                selectedServiceForm: null
            };
        case "SET_SERVICE_FORM":
            return {
                ...state,
                loading: false,
                error: null,
                selectedServiceForm: action.payload
            };
        case "GO_TO_THANK_YOU":
            return {
                ...state,
                goToThankYou: true
            };
        default:
            return state;
    }
};
const fieldsTypeToConvertToSelect = [
    "radio",
    "select"
];
const fieldsTypeToConvertToMultipleSelect = [
    "checkbox"
];
function SecondServiceForms({ classes , colors , goToThankYou , secondServiceSearchableMultiSelect =false  }) {
    const { domain , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_1__/* .useDomainContext */ .w)();
    const { setSkipToThankYou , isSecondServiceSubmitted  } = (0,_hooks_useFormContext__WEBPACK_IMPORTED_MODULE_2__/* .useFormContext */ .G)();
    const { 0: secondServiceState , 1: dispatch  } = (0,react__WEBPACK_IMPORTED_MODULE_3__.useReducer)(reducer, initialSecondServiceFormsState);
    const listOfServicesElements = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(()=>{
        return domain.categories.find((domainCategory)=>domainCategory.slug === category?.slug)?.secondServiceCategories?.map((secondService)=>secondService.secondServiceCategory);
    }, [
        category
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (listOfServicesElements && listOfServicesElements.length) {
            const slugs = [];
            const tags = {};
            listOfServicesElements.forEach((service)=>{
                slugs.push(service.slug);
                tags[service.label ?? service.name] = {
                    slug: service.slug,
                    active: false,
                    label: service.label ?? service.name
                };
            });
            dispatch({
                type: "INITIATE_SERVICES",
                payload: {
                    tags
                }
            });
        }
    }, [
        listOfServicesElements
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(()=>{
        if (secondServiceState.tags) {
            getSecondServiceForm();
        }
    }, [
        secondServiceState.tags
    ]);
    const groupingFormFields = (data)=>{
        const fields = [];
        data.steps.forEach((step)=>{
            step.fields.forEach((field)=>{
                if (fieldsTypeToConvertToSelect.includes(field.fieldType)) {
                    field.placeholder = "Select Option";
                    field.fieldType = "select";
                }
                if (fieldsTypeToConvertToMultipleSelect.includes(field.fieldType)) {
                    field.fieldType = "multipleSelect";
                }
                field.tag = step.tag;
                fields.push(field);
            });
        });
        return fields;
    };
    const resetFirstStepFormTitles = (data)=>{
        data.steps[0].title = "";
        data.steps[0].description = "";
    };
    const getServiceForm = async (categorySlug)=>{
        if (categorySlug) {
            dispatch({
                type: "SET_LOADING",
                payload: true
            });
            const { data , error  } = await (0,src_api__WEBPACK_IMPORTED_MODULE_4__/* .getDomainForm */ .OU)({
                categorySlug
            });
            if (error) {
                dispatch({
                    type: "SELECT_SERVICE_ERROR",
                    payload: error
                });
                return;
            }
            if (data) {
                const lastStep = data.steps[data.steps.length - 1];
                resetFirstStepFormTitles(data);
                const fields = groupingFormFields(data);
                const firstStep = {
                    ...data.steps[0]
                };
                firstStep.fields = fields;
                firstStep.TCPAMessage = lastStep.TCPAMessage;
                firstStep.buttonText = lastStep.buttonText;
                firstStep.includeTCPAMessage = lastStep.includeTCPAMessage;
                dispatch({
                    type: "SET_SERVICE_FORM",
                    payload: {
                        ...data,
                        stepToSendingData: 0,
                        steps: [
                            firstStep
                        ]
                    }
                });
            }
            dispatch({
                type: "SET_LOADING",
                payload: false
            });
        }
    };
    const toggleSecondService = (tag)=>{
        dispatch({
            type: "SET_LOADING",
            payload: true
        });
        if (secondServiceState.tags[tag].active) {
            dispatch({
                type: "REMOVE_SERVICE",
                payload: {
                    tag
                }
            });
        } else {
            dispatch({
                type: "SELECT_SERVICE",
                payload: {
                    tag
                }
            });
        }
        dispatch({
            type: "SET_LOADING",
            payload: false
        });
    };
    const getSecondServiceForm = ()=>{
        const slugs = Object.keys(secondServiceState.tags).filter((tag)=>secondServiceState.tags[tag].active).map((tag)=>secondServiceState.tags[tag].slug);
        const allSlugs = Object.keys(secondServiceState.tags).map((tag)=>secondServiceState.tags[tag].slug);
        slugs.length ? void getServiceForm(slugs.join(",")) : void getServiceForm(allSlugs.join(","));
    };
    const outerSectionStyle = {
        "--checkbox-color": colors?.primaryColor || "var(--global-form-buttons-background-color)",
        "--mainBackground-color": colors?.mainBackgroundColor,
        "--mainBorder-color": colors?.mainBorderColor,
        "--hoverRadio-color": colors?.hoverRadioColor ?? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_7__/* .lightenColor */ .tG)(colors?.primaryColor, 0.6),
        "--textHoverRadio-color": colors?.textHoverRadioColor,
        "--selectedRadio-color": colors?.selectedRadioColor ?? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_7__/* .lightenColor */ .tG)(colors?.primaryColor, 0.6),
        "--textSelectedRadio-color": colors?.textSelectedRadioColor,
        "--hoverCheckbox-color": colors?.hoverCheckboxColor ?? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_7__/* .lightenColor */ .tG)(colors?.primaryColor, 0.6),
        "--textHoverCheckbox-color": colors?.textHoverCheckboxColor,
        "--selectedCheckbox-color": colors?.selectedCheckboxColor ?? (colors?.primaryColor ? (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_7__/* .lightenColor */ .tG)(colors?.primaryColor, 0.6) : "#eee"),
        "--textSelectedCheckbox-color": colors?.textSelectedCheckboxColor
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: outerSectionStyle,
        className: `${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().secondServiceFormWrapper)} flex flex-col justify-between`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().secondServiceFormInnerWrapper),
            children: [
                !isSecondServiceSubmitted && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    id: "second-service-step",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                            className: "text-xl lg:text-2xl font-bold mb-2",
                            children: [
                                "We Received your ",
                                category?.label ?? category?.name,
                                " ",
                                "Request."
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            className: "text-base lg:text-xl font-light text-[#8F8F8F] mb-6",
                            children: "Do you need a quote for another service?"
                        })
                    ]
                }),
                secondServiceState.selectedServiceForm ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_form__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        colors: {
                            ...colors,
                            primaryColor: colors?.primaryColor || "var(--global-form-buttons-background-color)"
                        },
                        classes: {
                            formClassName: `${classes?.formClassName} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().secondServiceForm)}`,
                            formButtonClassName: `${classes?.formButtonClassName} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["form-button"])}`,
                            formStepInnerClassName: classes?.formStepInnerClassName,
                            stepClassName: `${classes?.stepClassName} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().step1)}`,
                            fieldsClassName: {
                                zipcodeExpandable: classes?.fieldsClassName?.zipcodeExpandable,
                                textarea: classes?.fieldsClassName?.textarea,
                                streetAddress: classes?.fieldsClassName?.streetAddress,
                                select: `${classes?.fieldsClassName?.select} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().select)}`,
                                input: classes?.fieldsClassName?.input,
                                date: classes?.fieldsClassName?.date,
                                radio: `${classes?.fieldsClassName?.radio} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["radio-field"])}`,
                                checkbox: `${classes?.fieldsClassName?.checkbox} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["checkbox-field"])}`,
                                all: classes?.fieldsClassName?.all
                            },
                            formFieldClassName: `${classes?.formFieldClassName} ${(_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["field-wrapper"])}`,
                            stepTitleClassName: classes?.stepTitleClassName,
                            stepDescriptionClassName: classes?.stepDescriptionClassName,
                            formProgressbarClassName: classes?.formProgressbarClassName,
                            labelAsTitleClassName: classes?.labelAsTitleClassName,
                            tcpaClassName: classes?.tcpaClassName,
                            fieldErrorMessageClassName: classes?.fieldErrorMessageClassName,
                            fieldNoteClassName: classes?.fieldNoteClassName,
                            fieldsWrapperClassName: classes?.fieldsWrapperClassName,
                            firstStepClass: classes?.firstStepClass,
                            formFieldDescriptionClassName: classes?.formFieldDescriptionClassName,
                            formFieldLabelClassName: classes?.formFieldLabelClassName,
                            formSubmitButtonClassName: classes?.formSubmitButtonClassName,
                            sellingPointClassName: classes?.sellingPointClassName,
                            stepTagClassName: classes?.stepTagClassName
                        },
                        showProgress: false,
                        form: secondServiceState.selectedServiceForm,
                        isSecondServiceForm: true,
                        goToThankYouPage: goToThankYou,
                        updateSecondServices: toggleSecondService,
                        tags: secondServiceState.tags,
                        activeSecondServices: secondServiceState.selectedServiceSlug,
                        secondServiceLoading: secondServiceState.loading,
                        searchableMultiSelect: secondServiceSearchableMultiSelect
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        secondServiceState.loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: " flex items-center w-full justify-center h-48",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_spinner__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                size: 35,
                                color: colors?.primaryColor || "#000"
                            })
                        }),
                        secondServiceState.error && !secondServiceState.loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().errorMessage),
                            children: "Something Went Wrong"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_8___default().buttons),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: `${classes?.formButtonClassName} order-2 sm:order-1`,
                                    style: {
                                        border: `1px solid ${colors?.primaryColor || "var(--global-form-buttons-background-color)"}`,
                                        backgroundColor: "#fff",
                                        color: "#000"
                                    },
                                    onClick: ()=>{
                                        setSkipToThankYou(true);
                                    },
                                    children: "No Thank You"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    type: "button",
                                    style: {
                                        backgroundColor: colors?.primaryColor || "var(--global-form-buttons-background-color)"
                                    },
                                    className: `${classes?.formButtonClassName} order-1 sm:order-2`,
                                    disabled: !secondServiceState.selectedServiceSlug.length,
                                    children: "Get My Free Quotes"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}


/***/ }),

/***/ 13677:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _form__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96119);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94264);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);





// import StepsNavigation from "./steps";
// import { formatPhoneNumber, getPhoneNumber } from "@lib/sharedUtils";
// import AffiliateOfferUrl from "../affiliateOfferUrl";
const FormOfferModal = (props)=>{
    const PII_FIELDS = [
        "toZipCode",
        "zipCode",
        "streetAddress",
        "firstName",
        "lastName",
        "phoneNumber",
        "email", 
    ];
    const { colors , form , stepsConfig , ignoreCategoryInThankYouPagePath  } = props;
    const { form: domainContextForm , exitModalOffer , category , locale , domain ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const updateFieldType = (field)=>{
        return field.fieldType === "radio" ? "select" : field.fieldType === "checkbox" ? "multiSelect" : field.fieldType;
    };
    const getConfigTitle = (cfgTitle)=>{
        if (typeof cfgTitle === "object" && cfgTitle !== null) {
            return cfgTitle?.[locale || "en"] ?? "";
        }
        return cfgTitle ?? "";
    };
    const getConfigButtonText = (cfgButtonText)=>{
        if (typeof cfgButtonText === "object" && cfgButtonText !== null) {
            return cfgButtonText?.[locale || "en"] ?? "Next";
        }
        return cfgButtonText ?? "Next";
    };
    // const [currentStep, setCurrentStep] = useState(0);
    const exitModalFormStepsConfig = domain?.config?.exitModalFormStepsConfig || category?.config?.exitModalFormStepsConfig || [];
    const offer = exitModalOffer?.[0];
    const _form = form ?? domainContextForm;
    // const { textBlocks } = _form;
    // const phoneNumber = getPhoneNumber(offer);
    const queryParams = [];
    if (offer) {
        queryParams.push(`categoryId=${offer?.category.id.toString()}`);
        queryParams.push(`zone=exitFormModal`);
    }
    const tcpaStepIndex = _form?.steps.findIndex((step)=>step.includeTCPAMessage) ?? -1;
    let result = null;
    if (exitModalFormStepsConfig && exitModalFormStepsConfig.length) {
        const stepNumberThatHaveZipCodeField = exitModalFormStepsConfig.findIndex((cfg)=>Array.isArray(cfg.fieldsCodeNames) ? cfg.fieldsCodeNames.includes("zipCode") : "zipCode" in cfg.fieldsCodeNames);
        result = {
            ..._form,
            steps: [
                ...Array.isArray(exitModalFormStepsConfig) ? exitModalFormStepsConfig.map((cfg)=>{
                    // Use reduce to collect fields from all steps
                    const fields = _form.steps.reduce((acc, step)=>{
                        step.fields.forEach((f)=>{
                            if (Array.isArray(cfg.fieldsCodeNames) ? cfg.fieldsCodeNames.includes(f.codeName) : f.codeName in cfg.fieldsCodeNames) {
                                acc.push({
                                    ...f,
                                    label: Array.isArray(cfg.fieldsCodeNames) ? f.label || step.title || "" : cfg.fieldsCodeNames[f.codeName]?.label || f.label || step.title || "",
                                    placeholder: Array.isArray(cfg.fieldsCodeNames) ? f.placeholder || ([
                                        "select",
                                        "radio",
                                        "multiSelect",
                                        "checkbox", 
                                    ].includes(f.fieldType) ? "Select option" : "") : cfg.fieldsCodeNames[f.codeName]?.placeholder,
                                    fieldType: updateFieldType(f)
                                });
                            }
                        });
                        return acc;
                    }, []);
                    const stepTitle = getConfigTitle(cfg?.title);
                    return {
                        title: stepTitle,
                        includeTCPAMessage: cfg.includeTCPAMessage ?? false,
                        TCPAMessage: cfg.includeTCPAMessage && tcpaStepIndex >= 0 ? _form.steps[tcpaStepIndex]?.TCPAMessage ?? null : null,
                        buttonText: getConfigButtonText(cfg?.buttonText),
                        fields,
                        description: "",
                        id: 1,
                        tooltip: ""
                    };
                }) : [], 
            ],
            stepToSendingData: 0,
            ...stepNumberThatHaveZipCodeField > -1 ? {
                stepToFetchBuyers: stepNumberThatHaveZipCodeField
            } : {}
        };
    } else {
        result = {
            ..._form,
            steps: [
                {
                    ..._form?.steps[0],
                    fields: []
                },
                {
                    ..._form?.steps.find((step)=>step.fields.find((field)=>PII_FIELDS.includes(field.codeName))),
                    includeTCPAMessage: true,
                    TCPAMessage: _form.steps[tcpaStepIndex]?.TCPAMessage ?? null,
                    buttonText: _form.steps[_form.steps.length - 1].buttonText,
                    description: "",
                    fields: [],
                    id: 2,
                    tooltip: ""
                }, 
            ],
            stepToSendingData: 0
        };
        _form?.steps.forEach((step)=>{
            step.fields.forEach((field)=>{
                if (PII_FIELDS.includes(field.codeName)) {
                    result?.steps[1].fields.push({
                        ...field,
                        fieldType: updateFieldType(field)
                    });
                } else {
                    result?.steps[0].fields.push({
                        ...field,
                        label: field.label || step.title || "",
                        fieldType: updateFieldType(field),
                        placeholder: field.placeholder || ([
                            "select",
                            "radio",
                            "multiSelect",
                            "checkbox", 
                        ].includes(field.fieldType) ? "Select option" : "")
                    });
                }
            });
        });
    }
    if (!result) {
        return null;
    }
    // const stepsCount = result.steps.length;
    // const result = {
    //     ..._form,
    //     steps: [
    //         {
    //             ..._form?.steps[0],
    //             fields: [] as Field[],
    //         },
    //         {
    //             ..._form?.steps.find((step) =>
    //                 step.fields.find((field) =>
    //                     PII_FIELDS.includes(field.codeName),
    //                 ),
    //             ),
    //             includeTCPAMessage: true,
    //             TCPAMessage: _form.steps[tcpaStep].TCPAMessage,
    //             buttonText: _form.steps[_form.steps.length - 1].buttonText,
    //             fields: [] as Field[],
    //         },
    //     ],
    //     stepToSendingData: 0,
    // };
    // const marketingMessage = textBlocks?.find(
    //     (item) => item.position === "form-inside-modal-marketing-message",
    // );
    // _form?.steps.forEach((step) => {
    //     step.fields.forEach((field) => {
    //         if (PII_FIELDS.includes(field.codeName)) {
    //             result.steps[1].fields.push({
    //                 ...field,
    //                 fieldType: updateFieldType(field),
    //             });
    //         } else {
    //             result.steps[0].fields.push({
    //                 ...field,
    //                 label: field.label || step.title || "",
    //                 fieldType: updateFieldType(field),
    //                 placeholder:
    //                     field.placeholder ||
    //                     ([
    //                         "select",
    //                         "radio",
    //                         "multiSelect",
    //                         "checkbox",
    //                     ].includes(field.fieldType)
    //                         ? "Select option"
    //                         : ""),
    //             });
    //         }
    //     });
    // });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "flex flex-col sm:flex-row",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "w-full bg-[#f8f8f8] relative max-w-[500px]",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_form__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: {
                    formClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().form),
                    stepClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().step),
                    fieldsClassName: {
                        radio: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["radio-field"]),
                        multiSelect: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["multi-select-field"])
                    },
                    formButtonClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-button"]),
                    formFieldLabelClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-label"]),
                    stepTitleClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-title"]),
                    fieldNoteClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["field-note"]),
                    formFieldClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["form-field"]),
                    stepDescriptionClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["step-description"]),
                    sellingPointClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["selling-point"]),
                    formStepInnerClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["steps-inner"]),
                    tcpaClassName: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().tcpa)
                },
                backButton: props?.backButton,
                showProgress: false,
                colors: {
                    ...colors,
                    primaryColor: colors.primaryColor || "var(--global-headerAndFooter-modals-button-background-color, #eb7f58)"
                },
                form: result,
                dynamicThankYouFields: [
                    "firstName",
                    "manufacturingYear",
                    "vehicleMake",
                    "vehicleModel", 
                ],
                isFormInsideOffersModal: true,
                // Follow the page form's thank-you behavior instead of
                // always redirecting. On inline (non-redirect) domains this
                // lets the page form show its inline thank-you after the
                // exit-modal submit, rather than navigating to /thank-you.
                goToThankYouPage: props.goToThankYouPage ?? false,
                ignoreCategoryInThankYouPagePath: ignoreCategoryInThankYouPagePath,
                stepsConfig: stepsConfig,
                onInlineThankYouShown: props.onInlineThankYouShown
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (FormOfferModal);


/***/ }),

/***/ 95301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function Loader({ size , className  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: `flex items-center ${className ?? ""}`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "animate-loader-spin",
            style: {
                width: `${size}px`,
                height: `${size}px`
            },
            role: "progressbar",
            color: "white",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                className: "block",
                viewBox: "22 22 44 44",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                    style: {
                        stroke: "currentcolor",
                        strokeDasharray: "80px,200px",
                        strokeDashoffset: 0
                    },
                    cx: "44",
                    cy: "44",
                    r: "20.2",
                    fill: "none",
                    strokeWidth: "3.6"
                })
            })
        })
    });
}


/***/ }),

/***/ 18740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90021);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79961);






function Modal({ children , closeIcon , width , active , backdropClosable , onClose , modalStyles , bodyStyles , header , modalClassName , wrapperClassName , pageBuilderVariables , closeButtonClassName , overflow , activeCloseOnEscButton , fontFamilyAsProp  }) {
    const { routeConfig , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { 0: mounted , 1: setMounted  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: animation , 1: setAnimation  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const startAnimation = ()=>{
        setTimeout(()=>{
            setAnimation(true);
        }, 100);
    };
    const resetAnimation = ()=>{
        setAnimation(false);
    };
    const handleEsc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((event)=>{
        if (event.key === "Escape") {
            onClose(); // close modal
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (mounted) {
            if (active) {
                if (activeCloseOnEscButton) {
                    document.addEventListener("keydown", handleEsc);
                }
                document.getElementsByTagName("html")[0].classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
                if (window.innerWidth > 1024) {
                    document.body.style.width = "calc(100% - 15px)";
                }
                startAnimation();
            } else {
                if (activeCloseOnEscButton) {
                    document.removeEventListener("keydown", handleEsc);
                }
                document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
                document.body.classList.remove("overflow-hidden");
                document.body.style.width = "";
                resetAnimation();
            }
        }
        return ()=>{
            if (activeCloseOnEscButton) {
                document.removeEventListener("keydown", handleEsc);
            }
            document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
            document.body.classList.remove("overflow-hidden");
            document.body.style.width = "";
            resetAnimation();
        };
    }, [
        active
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
    }, []);
    const getStyleObject = ()=>{
        return {
            ...pageBuilderVariables ? {
                ...pageBuilderVariables
            } : {},
            ...fontFamilyAsProp ? {
                fontFamily: fontFamilyAsProp
            } : routeConfig ? {
                fontFamily: (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFinalFontFamily */ .XR)(routeConfig, locale)
            } : {}
        };
    };
    if (mounted) {
        return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper)} ${active ? "flex" : "hidden"} ${wrapperClassName ?? ""}`,
                style: getStyleObject(),
                children: [
                    active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: backdropClosable ? onClose : undefined,
                        className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().backdrop)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modal)} ${wrapperClassName ? (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[wrapperClassName] : ""} 
                        ${modalClassName ?? ""}
                        ${overflow && overflow === "visible" ? (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["overflow-visible"]) : ""}
                        
                        duration-500 transition-all ease-in-out transform ${animation ? "-translate-y-0 opacity-100" : "-translate-y-10 opacity-0"}`,
                        style: {
                            width: width ? typeof width === "string" ? `${width}px` : width : "520px",
                            maxWidth: "calc(100vw - 32px)",
                            pointerEvents: "auto",
                            ...modalStyles
                        },
                        children: [
                            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: header
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().body)} `,
                                style: bodyStyles,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: onClose,
                                        type: "button",
                                        "aria-label": "Close",
                                        className: `${closeButtonClassName} ${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["close-button"])}`,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "close-icon",
                                            children: closeIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            height: "100%"
                                        },
                                        children: children
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }), document.body);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 77886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ RegulationsContent; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


const RegulationsContent = ({ title , description , children  })=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-3",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-4 flex text-center p-3 rounded flex-col gap-5",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "pb-1",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("strong", {
                                    className: "text-[22px]",
                                    children: title
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-[14px] text-[gray]",
                                children: description
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "border border-t-[lightgray]",
                children: children
            })
        ]
    });
};


/***/ }),

/***/ 65984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ S3Icon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function S3Icon({ image , svgClassName  }) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: image?.mimeType === "image/svg+xml" && image.imageData ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: `children:w-7 children:h-auto children:mx-auto ${svgClassName}`,
            dangerouslySetInnerHTML: {
                __html: image?.imageData
            }
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: `${svgClassName}`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: image?.fullPath,
                alt: image.id
            })
        })
    });
}


/***/ }),

/***/ 51716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8628);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_2__);



const Spinner = ({ size , className ="" , color , success  })=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            borderColor: success ? color : undefined,
            borderLeftColor: color,
            width: size ? `${size}px` : undefined,
            height: size ? `${size}px` : undefined
        },
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["circle-loader"])} ${success ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["load-complete"]) : ""} ${className ?? ""} spinner`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            style: {
                opacity: success ? 1 : 0,
                color
            },
            className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().checkmark)} ${success ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_2___default().draw) : ""}`
        })
    });
/* harmony default export */ __webpack_exports__["Z"] = (Spinner);


/***/ }),

/***/ 78963:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ArrowRightIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function ArrowRightIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21",
        height: "14",
        fill: "none",
        viewBox: "0 0 21 14",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            fill: "#fff",
            d: "M13.643 0l-1.41 1.41L16.813 6H.642v2h16.17l-4.59 4.59 1.42 1.41 7-7-7-7z"
        })
    });
}


/***/ }),

/***/ 69655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "47",
        height: "47",
        fill: "none",
        viewBox: "0 0 47 47",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M45.359 5.447A3.252 3.252 0 0045.35.85l.106.106a3.256 3.256 0 00-4.597-.009L23.865 17.941a1.003 1.003 0 01-1.424 0L5.447.947A3.252 3.252 0 00.85.956L.956.85a3.256 3.256 0 00-.009 4.597l16.994 16.994a1.003 1.003 0 010 1.424L.947 40.859a3.252 3.252 0 00.009 4.597L.85 45.35a3.256 3.256 0 004.597.009l16.994-16.994a1.003 1.003 0 011.424 0l16.994 16.994a3.252 3.252 0 004.597-.009l-.106.106a3.256 3.256 0 00.009-4.597L28.365 23.865a1.003 1.003 0 010-1.424L45.359 5.447z"
        })
    });
}


/***/ }),

/***/ 88736:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ TooltipIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function TooltipIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "325",
        height: "325",
        viewBox: "0 0 325 325",
        fill: "black",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M162.402 0C119.332 0 78.023 17.109 47.562 47.562C17.109 78.019 0 119.328 0 162.402C0 205.476 17.109 246.781 47.562 277.242C78.019 307.695 119.328 324.804 162.402 324.804C205.476 324.804 246.781 307.695 277.242 277.242C307.695 246.785 324.804 205.476 324.804 162.402C324.804 119.328 307.695 78.023 277.242 47.562C246.785 17.109 205.476 0 162.402 0V0ZM162.402 308C123.785 308 86.754 292.66 59.452 265.352C32.143 238.047 16.804 201.016 16.804 162.402C16.804 123.788 32.144 86.754 59.452 59.452C86.757 32.143 123.788 16.804 162.402 16.804C201.016 16.804 238.05 32.144 265.352 59.452C292.661 86.757 308 123.788 308 162.402C308 201.016 292.66 238.05 265.352 265.352C238.047 292.661 201.016 308 162.402 308Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M151.202 134.4L145.6 140.279V240.519L151.202 246.398H173.6L179.202 240.519V140.279L173.6 134.4H151.202Z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M151.202 78.4L145.6 84.0016V106.4L151.202 112.001H173.6L179.202 106.4V84.0016L173.6 78.4H151.202Z"
            })
        ]
    });
}


/***/ }),

/***/ 88446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WarningAlertIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function WarningAlertIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        className: "feather feather-alert-triangle",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "12",
                y1: "9",
                x2: "12",
                y2: "13"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("line", {
                x1: "12",
                y1: "17",
                x2: "12.01",
                y2: "17"
            })
        ]
    });
}


/***/ }),

/***/ 367:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useLegalLinkHandler; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _useModalContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67379);
// hooks/useLegalLinkHandler.ts


const useLegalLinkHandler = (ref)=>{
    const { setModal  } = (0,_useModalContext__WEBPACK_IMPORTED_MODULE_1__/* .useModal */ .d)();
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const container = ref.current;
        if (!container) return;
        const handleClick = (e)=>{
            const target = e.target;
            if (target.tagName.toLowerCase() === "a") {
                const href = target.getAttribute("href");
                if (!href) return;
                if (href.startsWith("/privacy-policy")) {
                    e.preventDefault();
                    setModal({
                        active: true,
                        content: "privacy"
                    });
                } else if (href.startsWith("/terms-and-conditions")) {
                    e.preventDefault();
                    setModal({
                        active: true,
                        content: "terms"
                    });
                }
            }
        };
        container.addEventListener("click", handleClick);
        return ()=>container.removeEventListener("click", handleClick);
    }, [
        ref,
        setModal
    ]);
};


/***/ }),

/***/ 21818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ usePrev; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const usePrev = (value)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};


/***/ }),

/***/ 70211:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useTranslation; }
/* harmony export */ });
/* harmony import */ var _useDomainContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88737);
/* eslint-disable @typescript-eslint/no-unsafe-call */ /* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-unsafe-return */ 
// type Content
const useTranslation = ()=>{
    const { content  } = (0,_useDomainContext__WEBPACK_IMPORTED_MODULE_0__/* .useDomainContext */ .w)();
    const translate = (key)=>{
        return content?.content?.[key]?.replace("{", "<span>")?.replace("}", "</span>") ?? key;
    };
    return {
        translate
    };
};


/***/ }),

/***/ 91173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

const useWindowSize = ()=>{
    const { 0: windowSize , 1: setWindowSize  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        width: 0,
        height: 0
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const handleResize = ()=>{
            setWindowSize({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    return windowSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useWindowSize);


/***/ }),

/***/ 11169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ delay; }
/* harmony export */ });
function delay(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}


/***/ }),

/***/ 90969:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ar": function() { return /* binding */ flattenDeep; },
/* harmony export */   "Q8": function() { return /* binding */ mapValues; },
/* harmony export */   "VS": function() { return /* binding */ keyBy; },
/* harmony export */   "Xh": function() { return /* binding */ cloneDeep; },
/* harmony export */   "cx": function() { return /* binding */ findIndex; },
/* harmony export */   "ei": function() { return /* binding */ pick; },
/* harmony export */   "fl": function() { return /* binding */ startCase; },
/* harmony export */   "mN": function() { return /* binding */ uniqBy; },
/* harmony export */   "qr": function() { return /* binding */ findLastIndex; },
/* harmony export */   "vl": function() { return /* binding */ lowerCase; },
/* harmony export */   "xH": function() { return /* binding */ flatten; }
/* harmony export */ });
/* unused harmony export get */
// Custom uniqBy function to remove duplicates based on a property
function uniqBy(array, key) {
    const seen = new Set();
    return array.filter((item)=>{
        const value = item[key];
        if (seen.has(value)) {
            return false;
        }
        seen.add(value);
        return true;
    });
}
// Custom flatten function to flatten array one level deep
function flatten(array) {
    const result = [];
    for(let i = 0; i < array.length; i++){
        result.push(...array[i]);
    }
    return result;
}
/**
 * Converts an array into an object keyed by a specific property.
 * @param array - The array to transform
 * @param key - The property name to use as the key
 * @returns An object where keys are the property values and values are the array items
 * @example keyBy([{id: 1, name: 'a'}, {id: 2, name: 'b'}], 'id') // {"1": {id: 1, name: 'a'}, "2": {id: 2, name: 'b'}}
 */ function keyBy(array, key) {
    const result = {};
    for(let i = 0; i < array.length; i++){
        const item = array[i];
        const keyValue = String(item[key]);
        result[keyValue] = item;
    }
    return result;
}
/**
 * Transforms all values in an object using an iteratee function or by extracting a property.
 * @param obj - The object to transform
 * @param iteratee - Either a function to transform values or a property key to extract
 * @returns A new object with transformed values
 * @example mapValues({a: {val: 1}, b: {val: 2}}, (v) => v.val * 2) // {a: 2, b: 4}
 * @example mapValues({a: {val: 1}, b: {val: 2}}, 'val') // {a: 1, b: 2}
 */ function mapValues(obj, iteratee) {
    const result = {};
    // Check if iteratee is a function or a property key
    const isFunction = typeof iteratee === "function";
    for(const k in obj){
        if (Object.prototype.hasOwnProperty.call(obj, k)) {
            result[k] = isFunction ? iteratee(obj[k], k) : obj[k][iteratee];
        }
    }
    return result;
}
/**
 * Creates a new object with only the specified properties from the source object.
 * @param obj - The source object
 * @param keys - Array of property keys to pick
 * @returns A new object containing only the specified keys
 * @example pick({a: 1, b: 2, c: 3}, ['a', 'c']) // {a: 1, c: 3}
 */ function pick(obj, keys) {
    const result = {};
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        if (key in obj) {
            result[key] = obj[key];
        }
    }
    return result;
}
/**
 * Finds the index of the first element in an array that matches the predicate.
 * @param array - The array to search
 * @param predicate - Function that tests each element
 * @returns The index of the first matching element, or -1 if not found
 * @example findIndex([1, 2, 3, 4], (n) => n > 2) // 2
 */ function findIndex(array, predicate) {
    for(let i = 0; i < array.length; i++){
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
}
/**
 * Finds the index of the last element in an array that matches the predicate.
 * Searches from right to left.
 * @param array - The array to search
 * @param predicate - Function that tests each element
 * @returns The index of the last matching element, or -1 if not found
 * @example findLastIndex([1, 2, 3, 2, 1], (n) => n === 2) // 3
 */ function findLastIndex(array, predicate) {
    for(let i = array.length - 1; i >= 0; i--){
        if (predicate(array[i], i, array)) {
            return i;
        }
    }
    return -1;
}
/**
 * Converts a string to start case (capitalizes the first letter of each word).
 * Handles camelCase, snake_case, kebab-case, and space-separated strings.
 * @param str - The string to convert
 * @returns The string in start case format
 * @example startCase('hello-world') // "Hello World"
 * @example startCase('helloWorld') // "Hello World"
 * @example startCase('hello_world') // "Hello World"
 */ function startCase(str) {
    return str// Split on camelCase, snake_case, kebab-case, spaces
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase
    .replace(/[_-]/g, " ") // snake_case, kebab-case
    .trim().split(/\s+/) // Split into words
    .map((word)=>word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(" ");
}
/**
 * Converts a string to lower case with spaces between words.
 * Handles camelCase, snake_case, and kebab-case.
 * @param str - The string to convert
 * @returns The string in lower case with spaces
 * @example lowerCase('HelloWorld') // "hello world"
 * @example lowerCase('hello-world') // "hello world"
 * @example lowerCase('hello_world') // "hello world"
 */ function lowerCase(str) {
    return str// Split on camelCase
    .replace(/([a-z])([A-Z])/g, "$1 $2")// Replace underscores and hyphens with spaces
    .replace(/[_-]/g, " ")// Replace multiple spaces with single space
    .replace(/\s+/g, " ").trim().toLowerCase();
}
/**
 * Recursively flattens a nested array to a single level.
 * @param array - The array to flatten (can be deeply nested)
 * @returns A completely flattened array
 * @example flattenDeep([1, [2, [3, [4]]]]) // [1, 2, 3, 4]
 * @example flattenDeep([[1, 2], [3, [4, 5]]]) // [1, 2, 3, 4, 5]
 */ function flattenDeep(array) {
    const result = [];
    for(let i = 0; i < array.length; i++){
        if (Array.isArray(array[i])) {
            result.push(...flattenDeep(array[i]));
        } else {
            result.push(array[i]);
        }
    }
    return result;
}
/**
 * Creates a deep clone of an object, array, or primitive value.
 * Handles nested objects, arrays, and Date instances.
 * @param obj - The value to clone
 * @returns A deep copy of the input value
 * @example cloneDeep({a: {b: 1}}) // {a: {b: 1}} (new reference)
 * @example cloneDeep([1, [2, 3]]) // [1, [2, 3]] (new reference)
 */ function cloneDeep(obj) {
    if (obj === null || typeof obj !== "object") {
        return obj;
    }
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    if (Array.isArray(obj)) {
        const arrCopy = [];
        for(let i = 0; i < obj.length; i++){
            arrCopy[i] = cloneDeep(obj[i]);
        }
        return arrCopy;
    }
    const objCopy = {};
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            objCopy[key] = cloneDeep(obj[key]);
        }
    }
    return objCopy;
}
/**
 * Safely retrieves a nested property value from an object using a path.
 * Returns undefined if the path doesn't exist, or defaultValue if provided.
 * @param obj - The object to query
 * @param path - The path to the property (string with dots or array)
 * @param defaultValue - Optional value to return instead of undefined
 * @returns The resolved value, defaultValue if provided and path doesn't exist, or undefined
 * @example get({a: {b: {c: 3}}}, 'a.b.c') // 3
 * @example get({a: {b: {c: 3}}}, 'a.b.x') // undefined
 * @example get({a: {b: {c: 3}}}, 'a.b.x', 'default') // 'default'
 * @example get({items: [1, 2, 3]}, 'items[1]') // 2
 */ function get(obj, path, defaultValue) {
    // Convert string path to array if needed
    const pathArray = Array.isArray(path) ? path : path.replace(/\[(\d+)\]/g, ".$1") // Convert array[0] to array.0
    .split(".").filter(Boolean); // Remove empty strings
    // Traverse the object
    let result = obj;
    for (const key of pathArray){
        if (result == null) {
            return defaultValue;
        }
        result = result[key];
    }
    return result !== undefined ? result : defaultValue;
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 42076:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ BuyerPhoneNumberService; }
/* harmony export */ });
/* harmony import */ var _lib_shared_cookies__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76309);
/* harmony import */ var _services_http_service__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4806);
// src/services/buyerPhoneNumberService.ts


class BuyerPhoneNumberService {
    static async handleApiCall(apiCallField, data) {
        switch(apiCallField?.toLowerCase()){
            case "zipcode":
                {
                    await this.handleZipcodeApiCall(data);
                    break;
                }
        }
    }
    /**
     * Fetches buyer phone number based on zipcode and category
     */ static async fetchPhoneNumberByZipcode(zipCode, categoryId) {
        const accessToken = (0,_lib_shared_cookies__WEBPACK_IMPORTED_MODULE_0__/* .getAccessToken */ .hP)();
        const config = {
            method: "post",
            url: `/api/phoneNumberByZipcode`,
            data: {
                zipCode,
                categoryId
            },
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${accessToken}`
            }
        };
        const { data  } = await (0,_services_http_service__WEBPACK_IMPORTED_MODULE_1__/* .apiHandler */ .G)(()=>_services_http_service__WEBPACK_IMPORTED_MODULE_1__/* ["default"].client */ .Z.client(config));
        return data?.data?.phoneNumber ?? null;
    }
    /**
     * Handles the complete zipcode API call flow with callbacks
     */ static async handleZipcodeApiCall(options) {
        try {
            const phoneNumber = await this.fetchPhoneNumberByZipcode(options.zipCode, options.categoryId);
            if (phoneNumber) {
                options.onSuccess?.(phoneNumber);
                return {
                    phoneNumber
                };
            } else {
                const errorMessage = "Something went wrong, please try again";
                options.onError?.(errorMessage);
                return {
                    phoneNumber: ""
                };
            }
        } catch (error) {
            const errorMessage1 = "Something went wrong, please try again";
            options.onError?.(errorMessage1);
            return {
                phoneNumber: ""
            };
        }
    }
}


/***/ }),

/***/ 87605:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "M": function() { return /* binding */ initDomTracingSafe; }
});

// UNUSED EXPORTS: initDomTracing

;// CONCATENATED MODULE: ./src/api/logDomChanges.ts
/**
 * Log DOM changes - sends each change individually to the backend (fire-and-forget)
 * @param session User session
 * @param domain Domain info
 * @param changes Array of DOM changes (each will be sent as a separate request)
 */ const LogDomChanges = ({ visitDetails , domain , changes  })=>{
    // Send each change as a separate request (fire-and-forget)
    changes.forEach((change)=>{
        try {
            // Validate change size before sending (prevent string overflow)
            const MAX_CHANGE_SIZE = 50000; // 50KB limit per change
            if (change.length > MAX_CHANGE_SIZE) {
                ;
                change = change.substring(0, MAX_CHANGE_SIZE) + "... [TRUNCATED]";
            }
            const payload = {
                data: {
                    change,
                    visitId: visitDetails.visitId,
                    platform: visitDetails.platform,
                    trafficSourceNetwork: visitDetails.trafficSourceNetwork,
                    trafficSource: visitDetails.trafficSource,
                    url: window.location.href,
                    domainName: domain.name,
                    domainId: domain.id,
                    source: "dom-changes"
                }
            };
            // Try to stringify to validate size before sending
            const payloadString = JSON.stringify(payload);
            if (payloadString.length > 100000) {
                ;
                return;
            }
            void fetch(`/api/log-dom-changes`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-DOMAIN-NAME": domain.name
                },
                body: payloadString
            });
        } catch (error) {
            ;
        }
    });
};

;// CONCATENATED MODULE: ./src/utils/domTracing.ts

/**
 * List of whitelisted script and iframe sources that should not be tracked
 * These are trusted third-party services and internal scripts
 */ const TRACING_IGNORED_IDS = [
    "inspector",
    "click-script",
    "trustedFormsScript",
    "LeadIdScript_campaign",
    "click-script-id",
    "metaPixel",
    "maxmind",
    "clarity",
    "googletagmanager",
    "googleapis",
    "LeadiD-ignore-element",
    "LeadiD-ignore-mutation",
    "_next",
    "trustedform",
    "bing",
    "lidstatic",
    "getclicky",
    "twitterPixel",
    "gppongmhjkpfnbhagpmjfkannfbllamg",
    "sc-static",
    "gstatic",
    "snap.licdn",
    "snapchat",
    "tiktok",
    "DummyFrame",
    "redditstatic.com",
    "doubleclick.net",
    "googleadservices.com",
    "connect.facebook.net",
    "sc-static.net/scevent.min.js",
    "https://analytics.tiktok.com/i18n/pixel/events.js",
    "_linkedin_partner_id",
    "snap.licdn.com",
    "js.zi-scripts.com/",
    "ct.pinterest.com/ct.html",
    "analytics.tiktok.com/",
    "@vue/compiler-dom",
    "spinner-line-fade-default",
    "onesignal.com",
    "cdn.onesignal.com",
    "cdn.taboola.com",
    "ct.pinterest.com", 
];
/** Pattern to match TrustedForm script IDs (e.g., tf123, tf456) */ const TF_ID_PATTERN = /^tf\d*$/;
/**
 * Configuration for the MutationObserver
 */ const OBSERVER_CONFIG = {
    attributes: true,
    childList: true,
    subtree: true
};
/**
 * Checks if a script element should be tracked
 * @param element - The DOM element to check
 * @returns true if the script should be tracked
 */ const shouldTrackScript = (element)=>{
    const src = element.getAttribute("src");
    const id = element.getAttribute("id");
    // Check if src or id contains ignored patterns
    const hasIgnoredSrc = src && TRACING_IGNORED_IDS.some((item)=>src.includes(item));
    const hasIgnoredId = id && TRACING_IGNORED_IDS.some((item)=>id.includes(item));
    const matchesTfPattern = id && TF_ID_PATTERN.test(id);
    const hasIgnoredText = element.outerHTML && TRACING_IGNORED_IDS.some((item)=>element.outerHTML.includes(item));
    return !hasIgnoredSrc && !hasIgnoredId && !matchesTfPattern && !hasIgnoredText;
};
/**
 * Checks if an iframe element should be tracked
 * @param element - The DOM element to check
 * @returns true if the iframe should be tracked
 */ const shouldTrackIframe = (element)=>{
    const className = element.getAttribute("class");
    const src = element.getAttribute("src");
    const name = element.getAttribute("name");
    const hasIgnoredClass = className && TRACING_IGNORED_IDS.some((item)=>className.includes(item));
    const hasIgnoredSrc = src && TRACING_IGNORED_IDS.some((item)=>src.includes(item));
    const hasIgnoredName = name && TRACING_IGNORED_IDS.some((item)=>name.includes(item));
    return !hasIgnoredClass && !hasIgnoredSrc && !hasIgnoredName && !!src;
};
/**
 * Checks if a div or button element should be tracked
 * Only tracks elements that appear to be injected by third-party scripts
 * @param element - The DOM element to check
 * @returns true if the element should be tracked
 */ const shouldTrackElement = (element)=>{
    const className = element.getAttribute("class");
    const id = element.getAttribute("id");
    // Ignore elements with our own classes or IDs
    const hasIgnoredClass = className && TRACING_IGNORED_IDS.some((item)=>className.includes(item));
    const hasIgnoredId = id && TRACING_IGNORED_IDS.some((item)=>id.includes(item));
    // Track if element has suspicious attributes that indicate third-party injection
    const hasSuspiciousAttrs = element.hasAttribute("data-ad") || element.hasAttribute("data-widget") || element.hasAttribute("data-tracking") || element.hasAttribute("data-pixel") || (className?.includes("ad-") ?? false) || (className?.includes("widget-") ?? false) || (className?.includes("popup-") ?? false) || (className?.includes("modal-") ?? false) || (id?.includes("ad-") ?? false) || (id?.includes("widget-") ?? false) || (id?.includes("popup-") ?? false);
    return !hasIgnoredClass && !hasIgnoredId && hasSuspiciousAttrs;
};
/**
 * Initializes DOM change tracking for scripts and iframes
 * Tracks malicious or unauthorized script/iframe injections
 *
 * @param params - Configuration object containing visitDetails and domain
 * @returns A cleanup function to disconnect the observer
 *
 * @example
 * ```tsx
 * const cleanup = initDomTracing({ visitDetails, domain });
 * // Later, to stop tracking:
 * cleanup();
 * ```
 */ const initDomTracing = (params)=>{
    const { visitDetails , domain  } = params;
    const targetNode = document.querySelector("body");
    const headTargetNode = document.querySelector("head");
    if (!targetNode || !headTargetNode) {
        ;
        return ()=>{}; // Return no-op cleanup function
    }
    /**
     * Callback function for MutationObserver
     * Processes DOM mutations and logs suspicious script/iframe additions
     */ const callback = (mutationList)=>{
        const changes = [];
        for (const mutation of mutationList){
            mutation.addedNodes?.forEach((node)=>{
                const element = node;
                // Track SCRIPT elements
                if (element.nodeName === "SCRIPT" && shouldTrackScript(element)) {
                    changes.push(`[SCRIPT] ${element.outerHTML}`);
                }
                // Track IFRAME elements
                if (element.nodeName === "IFRAME" && shouldTrackIframe(element)) {
                    changes.push(`[IFRAME] ${element.outerHTML}`);
                }
                // Track DIV elements (suspicious third-party injections)
                if (element.nodeName === "DIV" && shouldTrackElement(element)) {
                    changes.push(`[DIV] ${element.outerHTML.substring(0, 500)}...`);
                }
                // Track BUTTON elements (suspicious third-party injections)
                if (element.nodeName === "BUTTON" && shouldTrackElement(element)) {
                    changes.push(`[BUTTON] ${element.outerHTML.substring(0, 500)}...`);
                }
            });
        }
        // Log changes if any detected
        if (changes.length > 0) {
            LogDomChanges({
                visitDetails,
                domain,
                changes
            });
        }
    };
    const observer = new MutationObserver(callback);
    // Start observing both body and head for changes
    observer.observe(targetNode, OBSERVER_CONFIG);
    observer.observe(headTargetNode, OBSERVER_CONFIG);
    // Return cleanup function to disconnect observer
    return ()=>{
        observer.disconnect();
    };
};
/**
 * Initializes DOM tracing with browser compatibility check
 * Safe wrapper that checks for MutationObserver support before initializing
 *
 * @param params - Configuration object containing visitDetails and domain
 * @returns A cleanup function to disconnect the observer, or no-op if not supported
 *
 * @example
 * ```tsx
 * useEffect(() => {
 *   const cleanup = initDomTracingSafe({ visitDetails, domain });
 *   return cleanup; // Cleanup on unmount
 * }, []);
 * ```
 */ const initDomTracingSafe = (params)=>{
    const { visitDetails , domain  } = params;
    // Check for browser support and SSR
    if ( false || !window.MutationObserver) {
        return ()=>{}; // Return no-op cleanup function
    }
    // Only track for Google Search or Propel Media traffic on carwarrantyoffers.com
    const isGoogleSearch = visitDetails.trafficSourceNetwork?.toLowerCase() === "google search";
    const isPropelMedia = visitDetails.trafficSourceNetwork?.toLowerCase() === "propel media";
    const isTargetDomain = domain.name?.toLowerCase() === "carwarrantyoffers.com";
    // Track in two scenarios:
    // 1. Domain is carwarrantyoffers.com AND traffic is Google Search
    // 2. OR traffic is Propel Media (any domain)
    const shouldTrack = isTargetDomain && isGoogleSearch || isPropelMedia;
    if (!shouldTrack) {
        return ()=>{}; // Return no-op cleanup function
    }
    return initDomTracing(params);
};


/***/ }),

/***/ 92113:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__CoT60","link":"style_link__k7CXi"};

/***/ }),

/***/ 87668:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading-container":"ApiLoadingLabels_loading-container__bfkeU","label-wrapper":"ApiLoadingLabels_label-wrapper__vTMde","loading-label":"ApiLoadingLabels_loading-label__E9o9_","slide-in":"ApiLoadingLabels_slide-in__2H36k","slideInFromBottom":"ApiLoadingLabels_slideInFromBottom__czbBG","slide-up":"ApiLoadingLabels_slide-up__kklVj","slideUpAndOut":"ApiLoadingLabels_slideUpAndOut__PyGRE"};

/***/ }),

/***/ 41985:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otp-field":"styles_otp-field___fyFq","error-message":"styles_error-message__kdb5L","button":"styles_button__fKi2R","phone-number-modal-wrapper":"styles_phone-number-modal-wrapper__aII83","otpContainer":"styles_otpContainer__38ksr","phoneNumber":"styles_phoneNumber__Yjd_T","info-message":"styles_info-message__y3ELh","loading-spinner":"styles_loading-spinner__h5tcu","loading-title":"styles_loading-title__LR4nB"};

/***/ }),

/***/ 42327:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","disabled":"styles_disabled__2QAOb","checkbox-wrapper":"styles_checkbox-wrapper__4msNY","box":"styles_box__oXLdM","tcpa":"styles_tcpa__wV3j_"};

/***/ }),

/***/ 18732:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-modal-container":"styles_form-modal-container___hEJI","slide-bottom":"styles_slide-bottom__BQUtg","fade-slide-in":"styles_fade-slide-in__XRupX","form-modal-wrapper":"styles_form-modal-wrapper__wzsV8","back-button":"styles_back-button__w5oqV","arrow-back":"styles_arrow-back__btU5W","form-modal-close-button":"styles_form-modal-close-button__75TXN","inner":"styles_inner__vNaQF"};

/***/ }),

/***/ 14525:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","isSecondServiceFormMultipleSelect":"styles_isSecondServiceFormMultipleSelect__ijX1b","field":"styles_field__3DDJz","moreOptions":"styles_moreOptions__i57_U","radio":"styles_radio__K37KY","checkbox":"styles_checkbox___7yss","option":"styles_option__vHQv1","with-tooltip":"styles_with-tooltip__X4YMq","box":"styles_box__btrAX","textarea":"styles_textarea___57Jo","selectFieldTitle":"styles_selectFieldTitle__xO9B9","multipleSelectLabel":"styles_multipleSelectLabel___ggR6","multiSelectInput":"styles_multiSelectInput__JxVGa","multipleSelectLabelActive":"styles_multipleSelectLabelActive__T6FGI","multipleSelect":"styles_multipleSelect__Bvhh9","select":"styles_select__Q8SLS","empty":"styles_empty__PCA6D","otp-field":"styles_otp-field__XUJZP","otp-input":"styles_otp-input__0ob2t","focused":"styles_focused__JUAQg","error":"styles_error__q1JiW","disabled":"styles_disabled__lVYwE","otp-hidden-input":"styles_otp-hidden-input__zmfRo","date-picker":"styles_date-picker__Xcbad","mobile":"styles_mobile__QwQHp","text-input":"styles_text-input__AOJj9","date-input":"styles_date-input__2jX_s","desktop":"styles_desktop__wYL_d","day":"styles_day__UBh3B","month":"styles_month__lkiyt","year":"styles_year__QMJrk","search-wrapper":"styles_search-wrapper__kuO9B","radio-search":"styles_radio-search__TMbVU","streetAddressFieldWrapper":"styles_streetAddressFieldWrapper__F34oC","address-details-button":"styles_address-details-button__HExDu","addressDetails":"styles_addressDetails__GGo2e","zipcode-details-inside":"styles_zipcode-details-inside__cj8ND","addressDetailsInputs":"styles_addressDetailsInputs__Qdfeh","addressSubTitle":"styles_addressSubTitle__yP8Dc","loading":"styles_loading__hVu67","streetAddressField":"styles_streetAddressField__OWhKr","btnUpdate":"styles_btnUpdate__BNV4k","btnCancelUpdate":"styles_btnCancelUpdate__Q4GCU","expandableField":"styles_expandableField__gEIyX","fieldLabel":"styles_fieldLabel__nSgUj","topSection":"styles_topSection__OO4SG","btnSection":"styles_btnSection__ol_Hj","getZipCodeLoading":"styles_getZipCodeLoading__EaOc9","getZipCodeLoadSpinner":"styles_getZipCodeLoadSpinner__GJzBd","field-note":"styles_field-note__ht6WI","suggestionsWrapper":"styles_suggestionsWrapper__pnAJW","suggestion":"styles_suggestion__R6Hns","customLabel":"styles_customLabel__wOdAP","inputWrapper":"styles_inputWrapper__ZQAJb","labelWithIcon":"styles_labelWithIcon__Z_EFv","range":"styles_range___4Eai","range-value":"styles_range-value__GFoj9","error-message":"styles_error-message__NYjmO","errorBorder":"styles_errorBorder__0t_h1","no-background":"styles_no-background__yxvc0","labelLoading":"styles_labelLoading__dBoP_","loader-container":"styles_loader-container__7RjEM","loader":"styles_loader__XjgSA","rotation":"styles_rotation__UHT3y","input":"styles_input__5T7Tw"};

/***/ }),

/***/ 73504:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"styles_linkColor__w8y4F","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","container":"styles_container__VDlB2","orStyles":"styles_orStyles__FOXXQ"};

/***/ }),

/***/ 50890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","form-button":"styles_form-button__yWYAR","tcpaClassName":"styles_tcpaClassName__5CdTS","piiCompletionFormWrapper":"styles_piiCompletionFormWrapper__5cBAk","field-wrapper":"styles_field-wrapper__ki0tY","formFieldLabelClassName":"styles_formFieldLabelClassName__YsSkN","all":"styles_all__7G_lF","fieldsWrapperClassName":"styles_fieldsWrapperClassName__9zLGR","pii-missing-field-headline":"styles_pii-missing-field-headline__qI4zU","pii-other-fields-headline":"styles_pii-other-fields-headline__1cJsU"};

/***/ }),

/***/ 90796:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","progress-bar":"styles_progress-bar__t428f","percentage":"styles_percentage__i1uhQ","arrow":"styles_arrow__EMmUy","bar":"styles_bar__g1uQX","segments":"styles_segments__tu7RY","segment":"styles_segment__JDFf_","top-progress-bar":"styles_top-progress-bar__eqW56","progress-title":"styles_progress-title__qNbAM"};

/***/ }),

/***/ 83718:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","serviceLabel":"styles_serviceLabel__0j93H","activeService":"styles_activeService__k40Ow","category-icon":"styles_category-icon__gfCdL","buttons":"styles_buttons__CDEOV","secondServiceFormWrapper":"styles_secondServiceFormWrapper__KiNrb","secondServiceFormInnerWrapper":"styles_secondServiceFormInnerWrapper__owKBa","secondServiceForm":"styles_secondServiceForm__upa73","step1":"styles_step1__zL_pu","field-wrapper":"styles_field-wrapper__6Md4_","radio-field":"styles_radio-field__Lm8Yh","checkbox-field":"styles_checkbox-field__9TBTe","errorMessage":"styles_errorMessage__mxZ4j","select":"styles_select__jEUz1"};

/***/ }),

/***/ 67408:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form-inside-offers-close-button":"styles_form-inside-offers-close-button__NdeFs","steps-wrapper":"styles_steps-wrapper__wcJsS","step":"styles_step__iHMnj","title":"styles_title__Ai8hD","phoneNumberTitle":"styles_phoneNumberTitle__0F_cN","fadeIn":"styles_fadeIn__EMIfZ","description":"styles_description__Fnp9t","phoneNumberDescription":"styles_phoneNumberDescription__7iQA6","buttons":"styles_buttons__7L0Q7","conditionalLogic":"styles_conditionalLogic__lkmPL","form-offers-popup":"styles_form-offers-popup___iVPf","offer":"styles_offer__BszrW","form-inside-offers-container":"styles_form-inside-offers-container__dhGt8","sharedFieldsContainer":"styles_sharedFieldsContainer__A0jZV","sharedFieldsWrapper":"styles_sharedFieldsWrapper__iPDT2","field-label":"styles_field-label__Z40NC","arrow":"styles_arrow__1okHK","flickIcon":"styles_flickIcon__hv_tF","submit-button":"styles_submit-button__Wx0Tk","first-step-button-merged":"styles_first-step-button-merged__8OobB","progressBtn":"styles_progressBtn__TaAgL","loading":"styles_loading__tUjWB","disable-without-opacity":"styles_disable-without-opacity__bxFCF","thank-you-step":"styles_thank-you-step__2JAaR","thank-you-inner-step":"styles_thank-you-inner-step__QKMBE","extra-steps":"styles_extra-steps__SJ5fu","extra-step-inner":"styles_extra-step-inner__Vnxgu","field-description":"styles_field-description__6PwN6","form-field":"styles_form-field__hQTEx","as-title":"styles_as-title__KVC0D","error-message":"styles_error-message__Ku_HW","error":"styles_error___4H2C","tooltip":"styles_tooltip__K9Eoy","tooltip-icon":"styles_tooltip-icon__67cjA","form-error":"styles_form-error__nkJXW","progressBesideBackButton":"styles_progressBesideBackButton__a8_lt","progress-bar":"styles_progress-bar__vPx2O","top-progress-bar":"styles_top-progress-bar__0cPr6","back-button":"styles_back-button__UFX12","back-button-beside":"styles_back-button-beside___3Qkh","arrow-back":"styles_arrow-back__6T0rY","form":"styles_form__8dfnf","inner":"styles_inner__aMZiD","field-note":"styles_field-note__Dk678","loader":"styles_loader__hS6Ob","line-1":"styles_line-1__uDVIj","line-2":"styles_line-2__F35cj","line-3":"styles_line-3__ymcUZ","warningMessage":"styles_warningMessage__Ct_nO","submittingLabel":"styles_submittingLabel__XHmF_","tagGroup":"styles_tagGroup__02U1P","secondServiceField":"styles_secondServiceField__mN6Oy","tagGroupLabel":"styles_tagGroupLabel__Av_Rh","tagGroupLabelWrapper":"styles_tagGroupLabelWrapper__64frW","serviceListWrapper":"styles_serviceListWrapper__YT1br","serviceLabel":"styles_serviceLabel__bmMXr","activeService":"styles_activeService__G7G9t","category-icon":"styles_category-icon__JWWTB","buyer-logo":"styles_buyer-logo__t_gcx","hidden":"styles_hidden__M3aYR","PhoneNumber":"styles_PhoneNumber__gORTa","PhoneNumberBtn":"styles_PhoneNumberBtn__1ZQHN","shadow-pulse":"styles_shadow-pulse__RFp88","glare-effect":"styles_glare-effect___oA2f","input-wrapper-with-submit":"styles_input-wrapper-with-submit__zC2o5","circular-submit-button":"styles_circular-submit-button__C0gBD","flickIconBackWard":"styles_flickIconBackWard__iIBcs","loading-title":"styles_loading-title__SMTkN","rejectedAnswerErrorContainer":"styles_rejectedAnswerErrorContainer__PhfDc","rejectedAnswerErrorMessage":"styles_rejectedAnswerErrorMessage__yugdb","preStepTitle":"styles_preStepTitle__hcQvz"};

/***/ }),

/***/ 94264:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__N0ute","steps-inner":"styles_steps-inner__4OZJI","step-title":"styles_step-title__0b29k","label-as-step-title":"styles_label-as-step-title__cLIFM","step-description":"styles_step-description__hzvvY","fields-wrapper":"styles_fields-wrapper__OD8F6","form-button":"styles_form-button__rdk8p","form-field":"styles_form-field__CC_Vk","field-note":"styles_field-note__h6PeH","field-error-message":"styles_field-error-message__pMvy_","field":"styles_field__WN6At","radio-field":"styles_radio-field__AYZIY","multi-select-field":"styles_multi-select-field__PlD05","tcpa":"styles_tcpa__mOQzw","offer-bg-image":"styles_offer-bg-image__oVUdx"};

/***/ }),

/***/ 90021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__byYo9","overflow-visible":"modal_overflow-visible__Hw4yh","wrapper":"modal_wrapper__SOjyg","close-button":"modal_close-button__gm_NI","modal":"modal_modal__yslIq","body":"modal_body__ivFOU","header":"modal_header__nr_by","disclaimerModal":"modal_disclaimerModal__YCenG"};

/***/ }),

/***/ 8628:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"circle-loader":"style_circle-loader__KDhKQ","loader-spin":"style_loader-spin__dwuDT","load-complete":"style_load-complete__Qu8iX","checkmark":"style_checkmark__9Ih1T","draw":"style_draw___EUql"};

/***/ }),

/***/ 96502:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./en.json": 48704,
	"./es.json": 43449
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96502;

/***/ }),

/***/ 48704:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"DAY":"Day","MONTH":"Month","YEAR":"Year","JAN":"January","FEB":"February","MAR":"March","APR":"April","MAY":"May","JUN":"June","JUL":"July","AUG":"August","SEP":"September","OCT":"October","NOV":"November","DEC":"December"}');

/***/ }),

/***/ 43449:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"DAY":"Día","MONTH":"Mes","YEAR":"Año","JAN":"Enero","FEB":"Febrero","MAR":"Marco","APR":"Abril","MAY":"Mayo","JUN":"Junio","JUL":"Julio","AUG":"Agosto","SEP":"Septiembre","OCT":"Octubre","NOV":"Noviembre","DEC":"Diciembre"}');

/***/ })

}]);